(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["justbb-a3-photomosaic-layout"] && !Shopify.designMode) return;
  try {
    
  const sections = document.querySelectorAll('[data-a3-photomosaic]');

  sections.forEach((section) => {
    const form = document.querySelector('form[action*="/cart/add"]') || document.querySelector('form[data-type="add-to-cart-form"]') || document.getElementById('BuyButtons-ProductForm-main');
    const mainInput = section.querySelector('[data-a3-main-input]');
    const mosaicInput = section.querySelector('[data-a3-mosaic-input]');
    const mainPreview = section.querySelector('[data-a3-main-preview]');
    const mainImage = section.querySelector('[data-a3-main-image]');
    const tiles = Array.from(section.querySelectorAll('[data-a3-mosaic-tiles] span'));
    const printFileInput = section.querySelector('[data-a3-print-file]');
    const printStatus = section.querySelector('[data-a3-print-status]');
    const download = section.querySelector('[data-a3-download]');
    const addButtons = form ? Array.from(form.querySelectorAll('button[name="add"], button[type="submit"]')) : [];
    const previewUrls = [];
    const minMemoryPhotos = 8;
    const maxMemoryPhotos = 12;
    let printArtworkUrl = '';
    let printJob = 0;

    if (form && !form.id) {
      form.id = 'BuyButtons-ProductForm-main';
    }

    const text = (name) => section.dataset[name] || '';

    const createPreviewUrl = (file) => {
      const url = URL.createObjectURL(file);
      previewUrls.push(url);
      return url;
    };

    const clearPreviewUrls = () => {
      while (previewUrls.length > 0) {
        URL.revokeObjectURL(previewUrls.pop());
      }
    };

    const setPrintStatus = (message, type = '') => {
      if (!printStatus) {
        return;
      }

      printStatus.textContent = message;
      printStatus.classList.toggle('is-ready', type === 'ready');
      printStatus.classList.toggle('is-error', type === 'error');
    };

    const setAddButtonsReady = (ready) => {
      addButtons.forEach((button) => {
        button.toggleAttribute('data-a3-disabled', !ready);
        button.disabled = !ready;
      });
    };

    const resetPrintArtwork = () => {
      if (printArtworkUrl) {
        URL.revokeObjectURL(printArtworkUrl);
        printArtworkUrl = '';
      }

      if (download) {
        download.removeAttribute('href');
        download.hidden = true;
      }

      if (printFileInput) {
        printFileInput.value = '';
      }

      const boundInput = form ? form.querySelector('[data-a3-print-file-bound]') : null;
      if (boundInput) {
        boundInput.value = '';
      }
    };

    const updateMainPreview = () => {
      const file = mainInput && mainInput.files ? mainInput.files[0] : null;

      if (!file) {
        mainImage.removeAttribute('src');
        mainPreview.classList.remove('has-image');
        return;
      }

      mainImage.src = createPreviewUrl(file);
      mainPreview.classList.add('has-image');
    };

    const updateMosaicPreview = () => {
      const files = mosaicInput && mosaicInput.files ? Array.from(mosaicInput.files) : [];

      tiles.forEach((tile, index) => {
        const file = files[index];

        if (!file) {
          tile.style.removeProperty('background-image');
          tile.style.removeProperty('background-size');
          tile.style.removeProperty('background-position');
          return;
        }

        tile.style.backgroundImage = `url("${createPreviewUrl(file)}")`;
        tile.style.backgroundSize = 'cover';
        tile.style.backgroundPosition = 'center';
      });
    };

    const loadImageFile = (file) => new Promise((resolve, reject) => {
      const url = URL.createObjectURL(file);
      const image = new Image();

      image.onload = () => {
        URL.revokeObjectURL(url);
        resolve(image);
      };
      image.onerror = () => {
        URL.revokeObjectURL(url);
        reject(new Error(text('a3StatusError') || 'One of the uploaded photos could not be read.'));
      };
      image.src = url;
    });

    const drawImageCover = (context, image, x, y, width, height) => {
      const scale = Math.max(width / image.naturalWidth, height / image.naturalHeight);
      const drawWidth = image.naturalWidth * scale;
      const drawHeight = image.naturalHeight * scale;

      context.drawImage(image, x + (width - drawWidth) / 2, y + (height - drawHeight) / 2, drawWidth, drawHeight);
    };

    const drawPhoto = (context, image, x, y, width, height) => {
      context.save();
      context.shadowColor = 'rgba(70, 42, 24, 0.18)';
      context.shadowBlur = 28;
      context.shadowOffsetY = 14;
      context.fillStyle = '#ffffff';
      context.fillRect(x - 14, y - 14, width + 28, height + 28);
      context.restore();
      context.fillStyle = '#ffffff';
      context.fillRect(x - 14, y - 14, width + 28, height + 28);
      drawImageCover(context, image, x, y, width, height);
    };

    const canvasBlob = (canvas, type, quality) => new Promise((resolve, reject) => {
      canvas.toBlob((blob) => blob ? resolve(blob) : reject(new Error(text('a3StatusError') || 'Print-ready artwork could not be created.')), type, quality);
    });

    const createPrintReadyArtwork = async (job) => {
      const mainFile = mainInput && mainInput.files ? mainInput.files[0] : null;
      const memoryFiles = mosaicInput && mosaicInput.files ? Array.from(mosaicInput.files) : [];

      resetPrintArtwork();

      if (!mainFile || memoryFiles.length < minMemoryPhotos) {
        setAddButtonsReady(false);
        setPrintStatus(text('a3StatusNeedPhotos'), 'error');
        return;
      }

      setAddButtonsReady(false);
      setPrintStatus(text('a3StatusPreparing'));

      const memoryFilesForPrint = memoryFiles.slice(0, maxMemoryPhotos);
      const [mainImageForPrint, ...memoryImages] = await Promise.all([mainFile, ...memoryFilesForPrint].map(loadImageFile));
      if (job !== printJob) {
        return;
      }

      const width = 3508;
      const height = 4961;
      const margin = 190;
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');

      canvas.width = width;
      canvas.height = height;

      const background = context.createLinearGradient(0, 0, width, height);
      background.addColorStop(0, '#fffaf2');
      background.addColorStop(0.55, '#f7eadc');
      background.addColorStop(1, '#fff7ec');
      context.fillStyle = background;
      context.fillRect(0, 0, width, height);

      context.strokeStyle = '#d4ad5e';
      context.lineWidth = 42;
      context.strokeRect(50, 50, width - 100, height - 100);
      context.strokeStyle = 'rgba(124, 73, 24, 0.26)';
      context.lineWidth = 6;
      context.strokeRect(126, 126, width - 252, height - 252);

      const heroX = margin;
      const heroY = margin;
      const heroW = width - margin * 2;
      const heroH = 2760;
      drawPhoto(context, mainImageForPrint, heroX, heroY, heroW, heroH);

      const gridX = margin;
      const gridY = heroY + heroH + 165;
      const gridW = width - margin * 2;
      const gap = 46;
      const columns = 4;
      const rows = 3;
      const cellW = (gridW - gap * (columns - 1)) / columns;
      const cellH = (height - gridY - margin - gap * (rows - 1)) / rows;

      for (let row = 0; row < rows; row += 1) {
        for (let column = 0; column < columns; column += 1) {
          const image = memoryImages[(row * columns + column) % memoryImages.length];
          const x = gridX + column * (cellW + gap);
          const y = gridY + row * (cellH + gap);
          drawPhoto(context, image, x, y, cellW, cellH);
        }
      }

      const blob = await canvasBlob(canvas, 'image/jpeg', 0.96);
      if (job !== printJob) {
        return;
      }

      const file = new File([blob], 'justbb-a3-memory-collage-3508x4961-300dpi.jpg', { type: 'image/jpeg' });
      const files = new DataTransfer();

      files.items.add(file);
      if (printFileInput) {
        printFileInput.files = files.files;
      }
      if (form) {
        let boundInput = form.querySelector('[data-a3-print-file-bound]');

        if (!boundInput) {
          boundInput = document.createElement('input');
          boundInput.type = 'file';
          boundInput.name = 'properties[Print-ready A3 artwork]';
          boundInput.accept = 'image/jpeg';
          boundInput.hidden = true;
          boundInput.setAttribute('data-a3-print-file-bound', '');
          form.appendChild(boundInput);
        }

        boundInput.files = files.files;
      }
      printArtworkUrl = URL.createObjectURL(blob);

      if (download) {
        download.href = printArtworkUrl;
        download.hidden = false;
      }

      setAddButtonsReady(true);
      setPrintStatus(text('a3StatusReady'), 'ready');
    };

    const schedulePrintReadyArtwork = () => {
      printJob += 1;
      const job = printJob;

      resetPrintArtwork();
      createPrintReadyArtwork(job).catch((error) => {
        if (job !== printJob) {
          return;
        }

        setAddButtonsReady(false);
        setPrintStatus(error instanceof Error ? error.message : text('a3StatusError'), 'error');
      });
    };

    section.querySelectorAll('input[type="file"]').forEach((input) => {
      input.addEventListener('change', () => {
        const label = input.closest('label');
        const labelText = label ? label.querySelector('span') : null;
        const count = input.files ? input.files.length : 0;

        if (labelText && count > 0) {
          labelText.dataset.originalText = labelText.dataset.originalText || labelText.textContent;
          labelText.textContent = `${labelText.dataset.originalText} (${count} selected)`;
        }

        clearPreviewUrls();
        updateMainPreview();
        updateMosaicPreview();
        schedulePrintReadyArtwork();
      });
    });

    setAddButtonsReady(false);
    setPrintStatus(text('a3StatusEmpty'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["justbb-fathers-day-orders"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-customer-orders]').forEach((root) => {
    const screens = Array.from(root.querySelectorAll('[data-orders-screen]'));
    const emailForm = root.querySelector('[data-email-form]');
    const codeForm = root.querySelector('[data-code-form]');
    const emailInput = emailForm.elements.email;
    const codeInput = codeForm.elements.code;
    const notice = root.querySelector('[data-orders-notice]');
    const list = root.querySelector('[data-orders-list]');
    const template = root.nextElementSibling?.matches('template[data-justbb-order-card]')
      ? root.nextElementSibling
      : document.querySelector('template[data-justbb-order-card]');
    const cacheKey = 'justbb_verified_orders_v2';
    let currentEmail = '';
    let currentOrders = [];
    let pollTimer = null;

    const showScreen = (name) => {
      screens.forEach((screen) => { screen.hidden = screen.dataset.ordersScreen !== name; });
      history.replaceState(null, '', `${location.pathname}${location.search}#${name}`);
      notice.textContent = '';
      notice.removeAttribute('data-state');
      window.scrollTo({ top: Math.max(0, root.offsetTop - 90), behavior: 'smooth' });
    };
    const setNotice = (message, state = '') => { notice.textContent = message; state ? notice.dataset.state = state : notice.removeAttribute('data-state'); };
    const setBusy = (form, busy) => { Array.from(form.elements).forEach((control) => { control.disabled = busy; }); };
    const maskEmail = (email) => {
      const parts = email.split('@');
      if (parts.length !== 2) return email;
      const visible = parts[0].slice(0, Math.min(2, parts[0].length));
      return `${visible}${'•'.repeat(Math.max(3, parts[0].length - visible.length))}@${parts[1]}`;
    };
    const api = async (payload) => {
      const response = await fetch(root.dataset.ordersEndpoint, { method:'POST', headers:{ 'Content-Type':'application/json' }, body:JSON.stringify(payload) });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || 'We could not complete that request. Please try again.');
      return data;
    };
    const productLabel = (order) => {
      const products = Array.isArray(order.products) ? order.products.map((item) => typeof item === 'string' ? item : item.product || item.name).filter(Boolean) : [];
      return products.length ? products.join(' + ') : (order.product || 'Personalised gift');
    };
    const formatDate = (value, includeTime = false) => {
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      return new Intl.DateTimeFormat('en-AU', includeTime ? { dateStyle:'medium', timeStyle:'short' } : { dateStyle:'medium' }).format(date);
    };
    const renderOrderItems = (card, order) => {
      const container = card.querySelector('[data-order-items]');
      const items = Array.isArray(order.items) ? order.items : [];
      container.replaceChildren();
      if (!items.length) {
        const empty = document.createElement('p');
        empty.className = 'justbb-orders__privacy';
        empty.textContent = 'Uploaded design details are not available for this older order.';
        container.append(empty);
        return;
      }
      items.forEach((item, index) => {
        const row = document.createElement('article');
        row.className = 'justbb-order-item';
        const imageUrl = String(item.image_url || '');
        if (imageUrl) {
          const link = document.createElement('a');
          link.className = 'justbb-order-item__image-link';
          link.href = imageUrl;
          link.target = '_blank';
          link.rel = 'noopener';
          link.setAttribute('aria-label', `Open uploaded design for ${item.product || `item ${index + 1}`}`);
          const image = document.createElement('img');
          image.className = 'justbb-order-item__image';
          image.src = imageUrl;
          image.alt = `Uploaded design for ${item.product || `item ${index + 1}`}`;
          image.loading = 'lazy';
          link.append(image);
          row.append(link);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'justbb-order-item__image-placeholder';
          placeholder.textContent = 'Image unavailable';
          row.append(placeholder);
        }
        const copy = document.createElement('div');
        copy.className = 'justbb-order-item__copy';
        const product = document.createElement('strong');
        const magnetPhotoLabel = Number(item.photos_in_bundle) > 1
          ? ` — Bundle ${Number(item.bundle_index) || 1}, photo ${Number(item.photo_index) || 1} of ${Number(item.photos_in_bundle)}`
          : '';
        product.textContent = `${String(item.product || 'Personalised gift')}${magnetPhotoLabel}`;
        const file = document.createElement('span');
        file.textContent = String(item.image_name || `Uploaded design ${index + 1}`);
        copy.append(product, file);
        if (Number(item.width_cm) > 0 && Number(item.height_cm) > 0) {
          const size = document.createElement('span');
          size.textContent = `Print area: ${item.width_cm} × ${item.height_cm} cm`;
          copy.append(size);
        }
        const pickup = document.createElement('span');
        pickup.textContent = item.pickup === 'next_day' ? 'Next day pickup' : 'Same day pickup';
        copy.append(pickup);
        row.append(copy);
        container.append(row);
      });
    };
    const renderOrders = () => {
      list.replaceChildren();
      currentOrders.forEach((order, index) => {
        const card = template.content.firstElementChild.cloneNode(true);
        card.dataset.orderRef = order.order_ref;
        card.querySelector('[data-order-date]').textContent = `Ordered ${formatDate(order.created_at)}`;
        card.querySelector('[data-order-ref]').textContent = order.order_ref;
        const badge = card.querySelector('[data-order-badge]');
        badge.textContent = order.label;
        badge.dataset.status = order.status;
        card.querySelector('[data-order-products]').textContent = productLabel(order);
        card.querySelector('[data-order-quantity]').textContent = String(order.quantity || 1);
        card.querySelector('[data-order-total]').textContent = new Intl.NumberFormat('en-AU', { style:'currency', currency:'AUD' }).format(Number(order.total_cents || 0) / 100);
        card.querySelector('[data-order-message]').textContent = order.message;
        card.querySelector('[data-order-updated]').textContent = `Last updated ${formatDate(order.updated_at || order.created_at, true)}`;
        const details = card.querySelector('[data-order-details]');
        const toggle = card.querySelector('[data-order-toggle]');
        const detailsId = `justbb-order-details-${String(order.order_ref || index).replace(/[^a-z0-9_-]/gi, '-')}`;
        details.id = detailsId;
        toggle.setAttribute('aria-controls', detailsId);
        renderOrderItems(card, order);
        const setExpanded = (expanded) => {
          details.hidden = !expanded;
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? 'Hide order details' : 'View order details';
        };
        toggle.addEventListener('click', (event) => {
          event.stopPropagation();
          setExpanded(details.hidden);
        });
        card.addEventListener('click', (event) => {
          if (event.target.closest('a,button') || !details.hidden && event.target.closest('[data-order-details]')) return;
          setExpanded(details.hidden);
        });
        const displayedStage = order.status === 'COLLECTED' ? 4 : Math.min(4, Math.max(1, Number(order.stage || 1)));
        card.querySelectorAll('[data-stage]').forEach((step) => {
          const stage = Number(step.dataset.stage);
          step.classList.toggle('is-complete', order.status === 'COLLECTED' || stage < displayedStage);
          step.classList.toggle('is-current', order.status !== 'COLLECTED' && stage === displayedStage);
        });
        list.append(card);
      });
      if (!currentOrders.length) {
        const empty = document.createElement('p');
        empty.className = 'justbb-orders__privacy';
        empty.textContent = 'No orders were found for this verified email address.';
        list.append(empty);
      }
    };
    const cacheOrders = (customerName = '') => {
      try { sessionStorage.setItem(cacheKey, JSON.stringify({ email:currentEmail, customerName, orders:currentOrders, savedAt:Date.now() })); } catch (_) {}
    };
    const startPolling = () => {
      if (pollTimer) clearInterval(pollTimer);
      const refresh = async () => {
        const active = currentOrders.filter((order) => !['READY_FOR_COLLECTION','COLLECTED','REJECTED'].includes(order.status));
        if (!active.length) return;
        const results = await Promise.all(active.map(async (order) => {
          try {
            const response = await fetch(root.dataset.statusEndpoint, {
              method:'POST',
              headers:{ 'Content-Type':'application/json' },
              body:JSON.stringify({ order_ref:order.order_ref, client_order_id:order.client_order_id }),
              cache:'no-store'
            });
            if (!response.ok) return null;
            return await response.json();
          } catch (_) { return null; }
        }));
        let changed = false;
        results.forEach((status, index) => {
          if (!status) return;
          const order = active[index];
          const target = currentOrders.find((item) => item.order_ref === order.order_ref);
          if (!target) return;
          ['status','stage','label','message','updated_at'].forEach((key) => { if (status[key] !== undefined && target[key] !== status[key]) { target[key] = status[key]; changed = true; } });
        });
        if (changed) { renderOrders(); cacheOrders(root.querySelector('[data-customer-greeting]').dataset.customerName || ''); }
      };
      pollTimer = setInterval(refresh, 10000);
      root.querySelector('[data-refresh-orders]').onclick = async () => { setNotice('Refreshing your order statuses…'); await refresh(); setNotice('Order statuses are up to date.'); };
    };
    const showOrders = (data) => {
      currentOrders = Array.isArray(data.orders) ? data.orders : [];
      const greeting = root.querySelector('[data-customer-greeting]');
      const firstName = String(data.customer_name || '').trim().split(/\s+/)[0];
      greeting.dataset.customerName = data.customer_name || '';
      greeting.textContent = firstName ? `Hi ${firstName}, here are your latest orders and production updates.` : 'Here are your latest orders and production updates.';
      renderOrders();
      cacheOrders(data.customer_name || '');
      showScreen('orders');
      startPolling();
    };

    emailForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!emailForm.reportValidity()) return;
      currentEmail = emailInput.value.trim().toLowerCase();
      setBusy(emailForm, true); setNotice('Sending your private verification code…');
      try {
        const data = await api({ action:'request_code', email:currentEmail });
        root.querySelector('[data-masked-email]').textContent = maskEmail(currentEmail);
        setNotice(data.message || 'If we found orders for that email, your code is on its way.');
        showScreen('verify');
        setNotice(data.message || 'If we found orders for that email, your code is on its way.');
        setTimeout(() => codeInput.focus(), 100);
      } catch (error) { setNotice(error.message, 'error'); }
      finally { setBusy(emailForm, false); }
    });
    codeInput.addEventListener('input', () => { codeInput.value = codeInput.value.replace(/\D/g, '').slice(0, 6); });
    codeForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!codeForm.reportValidity()) return;
      setBusy(codeForm, true); setNotice('Securely finding your orders…');
      try { showOrders(await api({ action:'verify_code', email:currentEmail, code:codeInput.value })); }
      catch (error) { setNotice(error.message, 'error'); }
      finally { setBusy(codeForm, false); }
    });
    root.querySelector('[data-change-email]').addEventListener('click', () => { codeForm.reset(); showScreen('email'); emailInput.focus(); });
    root.querySelector('[data-resend-code]').addEventListener('click', async (event) => {
      const button = event.currentTarget; button.disabled = true; setNotice('Sending another code…');
      try { const data = await api({ action:'request_code', email:currentEmail }); setNotice(data.message); }
      catch (error) { setNotice(error.message, 'error'); }
      finally { setTimeout(() => { button.disabled = false; }, 60000); }
    });
    root.querySelector('[data-sign-out]').addEventListener('click', () => {
      if (pollTimer) clearInterval(pollTimer);
      sessionStorage.removeItem(cacheKey); currentOrders = []; currentEmail = ''; emailForm.reset(); codeForm.reset(); showScreen('email'); emailInput.focus();
    });
    try {
      const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
      if (cached && Date.now() - Number(cached.savedAt) < 30 * 60 * 1000 && Array.isArray(cached.orders)) {
        currentEmail = cached.email || ''; showOrders({ customer_name:cached.customerName, orders:cached.orders });
      } else { sessionStorage.removeItem(cacheKey); showScreen(location.hash === '#verify' ? 'email' : 'email'); }
    } catch (_) { sessionStorage.removeItem(cacheKey); showScreen('email'); }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["justbb-fathers-day-stall"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fathers-stall]').forEach((root) => {
    const form = root.querySelector('[data-stall-form]');
    const productCards = [...root.querySelectorAll('[data-product-card]')];
    const productCardRows = new Map();
    productCards.forEach((card) => {
      const row = document.createElement('div');
      row.className = 'fathers-stall__product-card-row';
      row.dataset.category = card.dataset.category;
      row.dataset.selected = 'false';
      const control = document.createElement('label');
      control.className = 'fathers-stall__card-quantity';
      control.hidden = true;
      const maxQuantity = Number(card.dataset.maxQuantity || 20);
      control.innerHTML = `<span>Quantity</span><span class="fathers-stall__quantity-control"><button type="button" data-card-quantity-minus aria-label="Decrease quantity">−</button><input type="number" min="1" max="${maxQuantity}" value="1" inputmode="numeric" data-card-quantity aria-label="Quantity"><button type="button" data-card-quantity-plus aria-label="Increase quantity">+</button></span>`;
      card.before(row);
      row.append(card, control);
      productCardRows.set(card.dataset.category, row);
    });
    const productValue = root.querySelector('[data-product-value]');
    const productsValue = root.querySelector('[data-products-value]');
    const productQuantitiesValue = root.querySelector('[data-product-quantities-value]');
    const designProductsValue = root.querySelector('[data-design-products-value]');
    const pickupScheduleValue = root.querySelector('[data-pickup-schedule-value]');
    const pricingRuleValue = root.querySelector('[data-pricing-rule]');
    const totalCentsValue = root.querySelector('[data-total-cents]');
    const frameSizeWrap = root.querySelector('[data-frame-size-wrap]');
    const frameSize = root.querySelector('[data-frame-size]');
    const a3Picker = root.querySelector('[data-a3-picker]');
    const collagePickerEyebrow = root.querySelector('[data-collage-picker-eyebrow]');
    const collagePickerHeading = root.querySelector('[data-collage-picker-heading]');
    const collagePickerCopy = root.querySelector('[data-collage-picker-copy]');
    const collagePickerSpec = root.querySelector('[data-collage-picker-spec]');
    const a3Layouts = root.querySelector('[data-a3-layouts]');
    const a3ThemePicker = root.querySelector('[data-a3-theme-picker]');
    const a3Themes = root.querySelector('[data-a3-themes]');
    const a3ThemeGuidance = root.querySelector('[data-a3-theme-guidance]');
    const a3ThemeNote = root.querySelector('[data-a3-theme-note]');
    const a3TitleWrap = root.querySelector('[data-a3-title-wrap]');
    const a3Title = root.querySelector('[data-a3-title]');
    const a3FrameChoice = root.querySelector('[data-a3-frame-choice]');
    const a3FrameSelect = root.querySelector('[data-a3-frame-select]');
    const a3DesignContinue = root.querySelector('[data-a3-design-continue]');
    const a3Editor = root.querySelector('[data-a3-editor]');
    const a3EditLayout = root.querySelector('[data-a3-edit-layout]');
    const collageEditLayoutLabel = root.querySelector('[data-collage-edit-layout-label]');
    const a3EditThemeWrap = root.querySelector('[data-a3-edit-theme-wrap]');
    const a3EditTheme = root.querySelector('[data-a3-edit-theme]');
    const a3EditTitleWrap = root.querySelector('[data-a3-edit-title-wrap]');
    const a3EditTitle = root.querySelector('[data-a3-edit-title]');
    const a3Canvas = root.querySelector('[data-a3-canvas]');
    const a3Slots = root.querySelector('[data-a3-slots]');
    const a3Input = root.querySelector('[data-a3-input]');
    const a3SingleInput = root.querySelector('[data-a3-single-input]');
    const a3Batch = root.querySelector('[data-a3-batch]');
    const a3SaveShopping = root.querySelector('[data-a3-save-shopping]');
    const designSavedBars = new Map([...root.querySelectorAll('[data-design-saved]')].map((bar) => [bar.dataset.designSaved, bar]));
    const a3PhotoAction = root.querySelector('[data-a3-photo-action]');
    const a3PhotoActionLabel = root.querySelector('[data-a3-photo-action-label]');
    const a3Progress = root.querySelector('[data-a3-progress]');
    const a3Crop = root.querySelector('[data-a3-crop]');
    const a3Zoom = root.querySelector('[data-a3-zoom]');
    const a3PanX = root.querySelector('[data-a3-pan-x]');
    const a3PanY = root.querySelector('[data-a3-pan-y]');
    let a3SelectedPhoto = 0;
    let a3UploadTarget = null;
    let a3Loading = false;
    let a3Drag = null;
    let a3LongPressTimer = 0;
    let a3SuppressClick = -1;
    let a3DesignStageComplete = false;
    const productSpec = root.querySelector('[data-product-spec]');
    const quantity = root.querySelector('[data-quantity]');
    const totalPrice = root.querySelector('[data-total-price]');
    const bundleSummary = root.querySelector('[data-bundle-summary]');
    const bundleName = root.querySelector('[data-bundle-name]');
    const regularPrice = root.querySelector('[data-regular-price]');
    const bundlePrice = root.querySelector('[data-bundle-price]');
    const bundleSaving = root.querySelector('[data-bundle-saving]');
    const photoModeWrap = root.querySelector('[data-photo-mode]');
    const photoModeInputs = [...root.querySelectorAll('[data-photo-mode-input]')];
    const photoWorkspace = root.querySelector('[data-photo-workspace]');
    const photoProgress = root.querySelector('[data-photo-progress]');
    const magnetTemplates = root.querySelector('[data-magnet-templates]');
    const magnetBatchInput = root.querySelector('[data-magnet-batch-input]');
    const uploadTitle = root.querySelector('[data-upload-title]');
    const defaultUploadTitle = uploadTitle.textContent;
    const imageInput = root.querySelector('[data-image-input]');
    const editor = root.querySelector('[data-image-editor]');
    const canvasWrap = root.querySelector('[data-canvas-wrap]');
    const canvas = root.querySelector('[data-editor-canvas]');
    const context = canvas.getContext('2d');
    const simulatorCanvas = document.createElement('canvas');
    const simulatorContext = simulatorCanvas.getContext('2d');
    const fitMode = root.querySelector('[data-fit-mode]');
    const zoom = root.querySelector('[data-zoom]');
    const syncZoomControl = (input) => {
      const controls = input.closest('[data-zoom-controls]');
      const value = Number(input.value);
      const percentage = `${Math.round(value * 100)}%`;
      controls.querySelector('[data-zoom-value]').textContent = percentage;
      input.setAttribute('aria-valuetext', percentage);
      controls.querySelectorAll('[data-zoom-step]').forEach((button) => {
        button.disabled = input.disabled || (Number(button.dataset.zoomStep) < 0 ? value <= Number(input.min) : value >= Number(input.max));
      });
    };
    root.querySelectorAll('[data-zoom-controls]').forEach((controls) => {
      const input = controls.querySelector('input[type="range"]');
      controls.querySelectorAll('[data-zoom-step]').forEach((button) => button.addEventListener('click', () => {
        if (input.disabled || button.disabled) return;
        input.value = String(Math.min(Number(input.max), Math.max(Number(input.min), Math.round((Number(input.value) + Number(button.dataset.zoomStep)) * 100) / 100)));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }));
      input.addEventListener('input', () => syncZoomControl(input));
      syncZoomControl(input);
    });
    const simulators = [...root.querySelectorAll('[data-product-simulator]')].map((element) => ({
      element,
      product: element.querySelector('[data-rotatable-product]'),
      surface: element.querySelector('[data-mockup-surface]'),
      message: element.querySelector('[data-mockup-message]'),
      controls: element.querySelector('[data-preview-controls]'),
      help: element.querySelector('[data-preview-help]'),
      rotation: element.querySelector('[data-preview-rotation]')
    }));
    const designProductWrap = root.querySelector('[data-design-product-wrap]');
    const designProduct = root.querySelector('[data-design-product]');
    const previewProductWrap = root.querySelector('[data-preview-product-wrap]');
    const previewProduct = root.querySelector('[data-preview-product]');
    const reviewPreviewProductWrap = root.querySelector('[data-review-preview-product-wrap]');
    const reviewPreviewProduct = root.querySelector('[data-review-preview-product]');
    const slotNavigations = [...root.querySelectorAll('[data-slot-navigation]')].map((element) => ({
      element,
      previous: element.querySelector('[data-slot-previous]'),
      next: element.querySelector('[data-slot-next]'),
      counter: element.querySelector('[data-slot-counter]')
    }));
    const submit = root.querySelector('[data-submit]');
    const status = root.querySelector('[data-form-status]');
    const progress = root.querySelector('.fathers-stall__progress');
    const mobileIntro = root.querySelector('.fathers-stall__mobile-intro');
    const confirmation = root.querySelector('[data-order-confirmation]');
    const confirmationOrderNumber = root.querySelector('[data-confirmation-order-number]');
    const confirmationEmail = root.querySelector('[data-confirmation-email]');
    const confirmationCopy = root.querySelector('[data-confirmation-copy]');
    const confirmationStatus = root.querySelector('[data-confirmation-status]');
    const paymentMethodInputs = [...root.querySelectorAll('input[name="payment_method"]')];
    const shopMore = root.querySelector('[data-shop-more]');
    const pages = [...root.querySelectorAll('[data-wizard-page]')];
    const pageLinks = [...root.querySelectorAll('[data-page-link]')];
    const reviewProduct = root.querySelector('[data-review-product]');
    const reviewQuantity = root.querySelector('[data-review-quantity]');
    const reviewCustomer = root.querySelector('[data-review-customer]');
    const reviewTotal = root.querySelector('[data-review-total]');
    const endpoint = root.dataset.intakeEndpoint;
    const maxBytes = Number(root.dataset.maxFileMb || 20) * 1024 * 1024;
    // A hyphen before a number is retained in dataset keys; read these attributes directly.
    const magnetTemplateUrls = {
      8: root.getAttribute('data-magnet-template-8'),
      11: root.getAttribute('data-magnet-template-11')
    };
    const magnetSheetLayouts = {
      8: [
        { x: 291, y: 158, width: 594, height: 593 },
        { x: 1589, y: 158, width: 594, height: 593 },
        { x: 291, y: 1017, width: 594, height: 593 },
        { x: 1589, y: 1017, width: 594, height: 593 },
        { x: 291, y: 1875, width: 594, height: 593 },
        { x: 1589, y: 1875, width: 594, height: 593 },
        { x: 291, y: 2733, width: 594, height: 593 },
        { x: 1589, y: 2733, width: 594, height: 593 }
      ],
      11: [
        { x: 139, y: 158, width: 594, height: 593 },
        { x: 1737, y: 149, width: 594, height: 593 },
        { x: 932, y: 589, width: 594, height: 593 },
        { x: 139, y: 1023, width: 594, height: 593 },
        { x: 1737, y: 1014, width: 594, height: 593 },
        { x: 932, y: 1455, width: 594, height: 593 },
        { x: 139, y: 1887, width: 594, height: 593 },
        { x: 1737, y: 1878, width: 594, height: 593 },
        { x: 932, y: 2319, width: 594, height: 593 },
        { x: 139, y: 2752, width: 594, height: 593 },
        { x: 1737, y: 2743, width: 594, height: 593 }
      ]
    };
    const state = { items: new Map(), category: '', copyIndex: 0, product: '', widthCm: 0, heightCm: 0, price: 0, photoMode: '', image: null, imageUrl: '', rotation: 0, zoom: 1, offsetX: 0, offsetY: 0, dragging: false, lastX: 0, lastY: 0, previewRotation: 0, previewDragging: false, previewLastX: 0 };
    let renderFrame = 0;
    let currentPage = 0;
    let furthestPage = 0;

    const setStatus = (message, statusState = '') => {
      status.textContent = message;
      status.dataset.state = statusState;
    };

    const money = (cents) => `${root.dataset.currencySymbol}${cents % 100 === 0 ? cents / 100 : (cents / 100).toFixed(2)}`;

    const selectedItems = () => [...state.items.values()];
    const isCollageProduct = (category) => category === 'frame' || category === 'acrylicframe' || category === 'mug';
    const collageFormats = {
      a3: { id: 'a3', widthMm: 297, heightMm: 420, label: 'A3 photo frame', shortLabel: 'A3', sheetLabel: 'one borderless A3 artwork' },
      acrylic: { id: 'acrylic', widthMm: 304.8, heightMm: 381, label: '12 × 15 acrylic frame', shortLabel: '12 × 15', sheetLabel: 'one 12 × 15-inch artwork' },
      mug: { id: 'mug', widthMm: 215, heightMm: 96, label: '11 oz mug wrap', shortLabel: 'mug', sheetLabel: 'one 21.5 × 9.6 cm mug wrap' }
    };
    const collageFormatId = (category) => category === 'acrylicframe' ? 'acrylic' : category === 'mug' ? 'mug' : 'a3';
    const collageFormat = (design, category = '') => collageFormats[design?.collage?.format || collageFormatId(category)] || collageFormats.a3;
    const blankDesign = (category) => ({ image: null, imageUrl: '', sourceFile: null, rotation: 0, zoom: 1, fitMode: category === 'tumbler' ? 'fill' : 'extend', previewRotation: 0, previewUrl: '', offsetXRatio: 0, offsetYRatio: 0, a3Configured: !isCollageProduct(category) });
    const syncDesignCopies = () => selectedItems().forEach((item) => {
      item.copies ??= [];
      const extraCopies = Math.max(0, item.quantity * item.photosPerUnit - 1);
      while (item.copies.length < extraCopies) item.copies.push(blankDesign(item.category));
      if (item.copies.length > extraCopies) item.copies.length = extraCopies;
    });
    const designSlots = () => selectedItems().flatMap((item) => {
      const designs = [item, ...(item.copies ?? [])];
      return designs.map((design, copyIndex) => {
        const bundleIndex = Math.floor(copyIndex / item.photosPerUnit) + 1;
        const photoIndex = (copyIndex % item.photosPerUnit) + 1;
        const label = item.photosPerUnit > 1
          ? `${item.product} — ${item.quantity > 1 ? `Bundle ${bundleIndex}, ` : ''}Photo ${photoIndex} of ${item.photosPerUnit}`
          : isCollageProduct(item.category)
            ? `${item.product} — ${item.category === 'mug' ? 'Mug' : 'Frame'} ${copyIndex + 1} (${design.collage ? `${a3Layout(design.collage.layout).count}-photo design` : 'single photo'})`
            : `${item.product} — Photo ${copyIndex + 1}`;
        return { item, design, category: item.category, copyIndex, bundleIndex, photoIndex, key: `${item.category}::${copyIndex}`, label };
      });
    });
    const activeDesign = () => {
      const item = state.items.get(state.category);
      return state.copyIndex === 0 ? item : item?.copies?.[state.copyIndex - 1];
    };
    // A3 collage geometry is in millimetres. Previews and final 300-DPI artwork
    // use the same rectangles; child originals are never replaced by thumbnails.
    const a3LayoutChoices = [
      { id: 'single', label: '1 · Full page', count: 1 },
      { id: 'duo', label: '2 · Feature stacked', count: 2 },
      { id: 'duo-even', label: '2 · Equal stacked', count: 2 },
      { id: 'duo-top', label: '2 · Slim top', count: 2 },
      { id: 'duo-bottom', label: '2 · Slim bottom', count: 2 },
      { id: 'duo-split', label: '2 · Equal columns', count: 2 },
      { id: 'duo-left', label: '2 · Wide left', count: 2 },
      { id: 'duo-right', label: '2 · Wide right', count: 2 },
      { id: 'story', label: '3 · Left feature', count: 3 },
      { id: 'story-right', label: '3 · Right feature', count: 3 },
      { id: 'story-top', label: '3 · Top feature', count: 3 },
      { id: 'story-bottom', label: '3 · Bottom feature', count: 3 },
      { id: 'story-rows', label: '3 · Equal rows', count: 3 },
      { id: 'story-columns', label: '3 · Equal columns', count: 3 },
      { id: 'story-top-split', label: '3 · Split top', count: 3 },
      { id: 'four', label: '4 · Hero + three', count: 4 },
      { id: 'four-bottom', label: '4 · Three + hero', count: 4 },
      { id: 'four-grid', label: '4 · Balanced grid', count: 4 },
      { id: 'four-rows', label: '4 · Equal rows', count: 4 },
      { id: 'four-columns', label: '4 · Equal columns', count: 4 },
      { id: 'four-side', label: '4 · Left feature', count: 4 },
      { id: 'four-side-right', label: '4 · Right feature', count: 4 },
      { id: 'five-feature', label: '5 · Hero + four', count: 5 },
      { id: 'five-bottom', label: '5 · Four + hero', count: 5 },
      { id: 'five-editorial', label: '5 · Editorial 2 + 3', count: 5 },
      { id: 'five-editorial-reverse', label: '5 · Editorial 3 + 2', count: 5 },
      { id: 'five-side', label: '5 · Side feature', count: 5 },
      { id: 'six', label: '6 · Magazine', count: 6 },
      { id: 'six-grid', label: '6 · Grid 2 × 3', count: 6 },
      { id: 'six-grid-wide', label: '6 · Grid 3 × 2', count: 6 },
      { id: 'six-side', label: '6 · Side feature', count: 6 },
      { id: 'six-top', label: '6 · Top feature', count: 6 },
      { id: 'seven-feature', label: '7 · Hero gallery', count: 7 },
      { id: 'seven-side', label: '7 · Side gallery', count: 7 },
      { id: 'eight-grid', label: '8 · Grid 2 × 4', count: 8 },
      { id: 'eight-grid-wide', label: '8 · Grid 4 × 2', count: 8 },
      { id: 'eight-feature', label: '8 · Hero gallery', count: 8 },
      { id: 'eight-side', label: '8 · Side gallery', count: 8 },
      { id: 'nine', label: '9 · Mosaic', count: 9 },
      { id: 'nine-grid', label: '9 · Grid 3 × 3', count: 9 },
      { id: 'ten-grid', label: '10 · Grid 2 × 5', count: 10 },
      { id: 'ten-wide', label: '10 · Grid 5 × 2', count: 10 },
      { id: 'ten-feature', label: '10 · Hero gallery', count: 10 },
      { id: 'twelve', label: '12 · Editorial gallery', count: 12 },
      { id: 'twelve-grid', label: '12 · Grid 3 × 4', count: 12 },
      { id: 'fifteen-grid', label: '15 · Grid 3 × 5', count: 15 },
      { id: 'sixteen-grid', label: '16 · Grid 4 × 4', count: 16 },
      { id: 'twenty-grid', label: '20 · Grid 4 × 5', count: 20 }
    ];
    const mugThemeChoices = [
      { id: 'mug-plain-photo', label: 'Plain photo mug', count: 1, asset: '', slots: [
        { x: 0, y: 0, width: 215, height: 96, shape: 'rectangle' }
      ] },
      { id: 'mug-best-dad-ever', label: 'Best Dad Ever', count: 1, asset: root.dataset.mugThemeBestDadEver, slots: [
        { x: 47.5, y: 26.5, width: 119, height: 48, shape: 'rounded', radius: 5 }
      ] },
      { id: 'mug-dad-and-me', label: 'Dad & Me', count: 2, asset: root.dataset.mugThemeDadAndMe, slots: [
        { x: 56, y: 6, width: 88, height: 82, shape: 'ellipse' },
        { x: 149, y: 32, width: 47, height: 46, shape: 'rounded', radius: 7 }
      ] },
      { id: 'mug-dad-fuel', label: 'Dad Fuel', count: 3, asset: root.dataset.mugThemeDadFuel, slots: [
        { x: 13.5, y: 12.5, width: 45, height: 30, shape: 'rounded', radius: 5 },
        { x: 13.5, y: 48.5, width: 45, height: 33.5, shape: 'rounded', radius: 5 },
        { x: 148.5, y: 15.5, width: 50, height: 66, shape: 'rounded', radius: 6 }
      ] },
      { id: 'mug-first-fathers-day', label: 'First Father’s Day', count: 3, asset: root.dataset.mugThemeFirstFathersDay, slots: [
        { x: 24.5, y: 52.5, width: 37, height: 31.5, shape: 'heart' },
        { x: 74, y: 7, width: 72, height: 78.5, shape: 'arch' },
        { x: 154.5, y: 46.5, width: 40, height: 35.5, shape: 'heart' }
      ] },
      { id: 'mug-grandads-garden', label: 'Grandad’s Garden', count: 3, asset: root.dataset.mugThemeGrandadsGarden, slots: [
        { x: 15, y: 11, width: 51, height: 70, shape: 'ellipse' },
        { x: 147.5, y: 13, width: 49.5, height: 30, shape: 'rounded', radius: 5 },
        { x: 147.5, y: 49.5, width: 49.5, height: 30.5, shape: 'rounded', radius: 5 }
      ] },
      { id: 'mug-my-hero-dad', label: 'My Hero Dad', count: 3, asset: root.dataset.mugThemeMyHeroDad, slots: [
        { x: 19.5, y: 45, width: 37, height: 34, shape: 'ellipse' },
        { x: 67.5, y: 15, width: 83.5, height: 57, shape: 'rounded', radius: 4 },
        { x: 161.5, y: 29.5, width: 40, height: 43, shape: 'ellipse' }
      ] },
      { id: 'mug-our-favourite-guy', label: 'Our Favourite Guy', count: 5, asset: root.dataset.mugThemeOurFavouriteGuy, slots: [
        { x: 8, y: 31.2, width: 32.2, height: 36.3, shape: 'rounded', radius: 1, angle: -5 },
        { x: 43.5, y: 15.9, width: 32.3, height: 30.7, shape: 'rounded', radius: 1, angle: 6 },
        { x: 52.3, y: 49.3, width: 32.8, height: 27.7, shape: 'rounded', radius: 1, angle: 4 },
        { x: 135.5, y: 17, width: 29.8, height: 32.8, shape: 'rounded', radius: 1, angle: -7 },
        { x: 174.2, y: 31.1, width: 30, height: 34.6, shape: 'rounded', radius: 1, angle: 7 }
      ] },
      { id: 'mug-super-dad', label: 'Super Dad', count: 3, asset: root.dataset.mugThemeSuperDad, slots: [
        { x: 17, y: 50, width: 40, height: 37, shape: 'ellipse' },
        { x: 75, y: 11.5, width: 67, height: 73, shape: 'shield' },
        { x: 159, y: 50, width: 40, height: 37, shape: 'ellipse' }
      ] }
    ];
    const allCollageLayoutChoices = [...a3LayoutChoices, ...mugThemeChoices];
    const mugTheme = (id) => mugThemeChoices.find((theme) => theme.id === id) || mugThemeChoices[0];
    const mugThemeImageCache = new Map();
    mugThemeChoices.forEach((theme) => {
      if (!theme.asset) return;
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => window.requestAnimationFrame(() => {
        designSlots().filter((slot) => slot.category === 'mug' && slot.design.collage?.layout === theme.id)
          .forEach((slot) => refreshA3Composition(slot.design));
        if (state.category === 'mug') { syncA3Editor(); render(); }
      });
      image.src = theme.asset;
      mugThemeImageCache.set(theme.id, image);
    });
    const acrylicLayoutIds = new Set(['single']);
    const collageLayoutsForCategory = (category) => category === 'acrylicframe'
      ? a3LayoutChoices.filter((layout) => acrylicLayoutIds.has(layout.id))
      : category === 'mug'
        ? mugThemeChoices
        : a3LayoutChoices;
    const a3ThemeChoices = [
      { id: 'clean', label: 'Minimal White', background: '#ffffff', foreground: '#151515', accent: '#800b32', title: '', font: '"Avenir Next", Montserrat, Arial, sans-serif', weight: 800 },
      { id: 'navy', label: 'Midnight Editorial', background: '#132238', foreground: '#ffffff', accent: '#68c3c0', title: 'HAPPY FATHER’S DAY', font: '"Arial Black", "Avenir Next", Arial, sans-serif', weight: 800 },
      { id: 'burgundy', label: 'Modern Burgundy', background: '#fff7f8', foreground: '#5d1730', accent: '#a30d43', title: 'HAPPY FATHER’S DAY', font: '"Trebuchet MS", "Avenir Next", Arial, sans-serif', weight: 800 },
      { id: 'kraft', label: 'Warm Neutral', background: '#e9dfcf', foreground: '#302823', accent: '#9a6434', title: 'DAD, YOU’RE THE BEST', font: '"Gill Sans", "Avenir Next", Arial, sans-serif', weight: 700 },
      { id: 'sky', label: 'Fresh Blue', background: '#eef7fa', foreground: '#163c50', accent: '#2b8ba3', title: 'BEST DAD EVER', font: '"Avenir Next", Montserrat, Arial, sans-serif', weight: 800 },
      { id: 'black-gold', label: 'Luxe Black & Gold', background: '#111214', foreground: '#ffffff', accent: '#d7b45b', title: 'HAPPY FATHER’S DAY', font: 'Futura, "Avenir Next", Arial, sans-serif', weight: 700 }
    ];
    const a3Layout = (id) => allCollageLayoutChoices.find((layout) => layout.id === id) || a3LayoutChoices[0];
    const a3Theme = (id) => a3ThemeChoices.find((theme) => theme.id === id) || a3ThemeChoices[0];
    const a3Greeting = (design) => {
      if (!design?.collage) return '';
      const theme = a3Theme(design.collage.theme);
      if (theme.id === 'clean') return '';
      const value = typeof design.collage.title === 'string' ? design.collage.title : theme.title;
      return value.replace(/\s+/g, ' ').trim().slice(0, 60);
    };
    const a3Rects = (id, themeId = 'clean', formatId = 'a3') => {
      const layout = a3Layout(id);
      const format = collageFormats[formatId] || collageFormats.a3;
      if (format.id === 'mug') return mugTheme(id).slots.map((slot) => ({ ...slot }));
      const sheetWidth = format.widthMm, sheetHeight = format.heightMm;
      if (layout.id === 'single') return [{ x: 0, y: 0, width: sheetWidth, height: sheetHeight }];
      const margin = 10, gap = 4, width = sheetWidth - margin * 2, top = a3Theme(themeId).id === 'clean' ? margin : 46, height = sheetHeight - top - margin;
      const row = (y, rowHeight, weights) => {
        const usable = width - gap * (weights.length - 1), total = weights.reduce((sum, weight) => sum + weight, 0);
        let x = margin;
        return weights.map((weight) => {
          const rect = { x, y, width: usable * weight / total, height: rowHeight };
          x += rect.width + gap;
          return rect;
        });
      };
      const rows = (weights) => {
        const usable = height - gap * (weights.length - 1), total = weights.reduce((sum, weight) => sum + weight, 0);
        let y = top;
        return weights.map((weight) => {
          const result = { y, height: usable * weight / total };
          y += result.height + gap;
          return result;
        });
      };
      const column = (x, columnWidth, weights) => {
        const usable = height - gap * (weights.length - 1), total = weights.reduce((sum, weight) => sum + weight, 0);
        let y = top;
        return weights.map((weight) => {
          const rect = { x, y, width: columnWidth, height: usable * weight / total };
          y += rect.height + gap;
          return rect;
        });
      };
      const grid = (rowCount, columnCount) => {
        const r = rows(Array(rowCount).fill(1));
        return r.flatMap((item) => row(item.y, item.height, Array(columnCount).fill(1)));
      };
      if (layout.id === 'duo') {
        const r = rows([1.45, 1]);
        return [...row(r[0].y, r[0].height, [1]), ...row(r[1].y, r[1].height, [1])];
      }
      if (layout.id === 'duo-even') return grid(2, 1);
      if (layout.id === 'duo-top') {
        const r = rows([.72, 1.55]);
        return r.flatMap((item) => row(item.y, item.height, [1]));
      }
      if (layout.id === 'duo-bottom') {
        const r = rows([1.55, .72]);
        return r.flatMap((item) => row(item.y, item.height, [1]));
      }
      if (layout.id === 'duo-split') return row(top, height, [1, 1]);
      if (layout.id === 'duo-left') return row(top, height, [1.55, .75]);
      if (layout.id === 'duo-right') return row(top, height, [.75, 1.55]);
      if (layout.id === 'story') {
        const usable = width - gap, leftWidth = usable * .62, rightWidth = usable - leftWidth, rightHeight = (height - gap) / 2;
        return [
          { x: margin, y: top, width: leftWidth, height },
          { x: margin + leftWidth + gap, y: top, width: rightWidth, height: rightHeight },
          { x: margin + leftWidth + gap, y: top + rightHeight + gap, width: rightWidth, height: rightHeight }
        ];
      }
      if (layout.id === 'story-right') {
        const usable = width - gap, leftWidth = usable * .38, rightWidth = usable - leftWidth, leftHeight = (height - gap) / 2;
        return [
          { x: margin, y: top, width: leftWidth, height: leftHeight },
          { x: margin, y: top + leftHeight + gap, width: leftWidth, height: leftHeight },
          { x: margin + leftWidth + gap, y: top, width: rightWidth, height }
        ];
      }
      if (layout.id === 'story-top') {
        const r = rows([1.45, 1]);
        return [...row(r[0].y, r[0].height, [1]), ...row(r[1].y, r[1].height, [1, 1])];
      }
      if (layout.id === 'story-bottom') {
        const r = rows([1, 1.45]);
        return [...row(r[0].y, r[0].height, [1, 1]), ...row(r[1].y, r[1].height, [1])];
      }
      if (layout.id === 'story-rows') return grid(3, 1);
      if (layout.id === 'story-columns') return row(top, height, [1, 1, 1]);
      if (layout.id === 'story-top-split') {
        const r = rows([1, 1.45]);
        return [...row(r[0].y, r[0].height, [1, 1]), ...row(r[1].y, r[1].height, [1])];
      }
      if (layout.id === 'four') {
        const r = rows([1.45, 1]);
        return [...row(r[0].y, r[0].height, [1]), ...row(r[1].y, r[1].height, [1, 1, 1])];
      }
      if (layout.id === 'four-bottom') {
        const r = rows([1, 1.45]);
        return [...row(r[0].y, r[0].height, [1, 1, 1]), ...row(r[1].y, r[1].height, [1])];
      }
      if (layout.id === 'four-grid') {
        const r = rows([1, 1]);
        return r.flatMap((item) => row(item.y, item.height, [1, 1]));
      }
      if (layout.id === 'four-rows') return grid(4, 1);
      if (layout.id === 'four-columns') return row(top, height, [1, 1, 1, 1]);
      if (layout.id === 'four-side') {
        const usable = width - gap, leftWidth = usable * .62, rightWidth = usable - leftWidth;
        const rightRows = rows([1, 1, 1]);
        return [
          { x: margin, y: top, width: leftWidth, height },
          ...rightRows.map((item) => ({ x: margin + leftWidth + gap, y: item.y, width: rightWidth, height: item.height }))
        ];
      }
      if (layout.id === 'four-side-right') {
        const usable = width - gap, leftWidth = usable * .38, rightWidth = usable - leftWidth;
        return [
          ...column(margin, leftWidth, [1, 1, 1]),
          { x: margin + leftWidth + gap, y: top, width: rightWidth, height }
        ];
      }
      if (layout.id === 'five-feature') {
        const r = rows([1.55, 1]);
        return [...row(r[0].y, r[0].height, [1]), ...row(r[1].y, r[1].height, [1, 1, 1, 1])];
      }
      if (layout.id === 'five-bottom') {
        const r = rows([1, 1.55]);
        return [...row(r[0].y, r[0].height, [1, 1, 1, 1]), ...row(r[1].y, r[1].height, [1])];
      }
      if (layout.id === 'five-editorial') {
        const r = rows([1, 1.25]);
        return [...row(r[0].y, r[0].height, [1.35, 1]), ...row(r[1].y, r[1].height, [1, 1, 1])];
      }
      if (layout.id === 'five-editorial-reverse') {
        const r = rows([1.25, 1]);
        return [...row(r[0].y, r[0].height, [1, 1, 1]), ...row(r[1].y, r[1].height, [1.35, 1])];
      }
      if (layout.id === 'five-side') {
        const usable = width - gap, leftWidth = usable * .56, rightWidth = usable - leftWidth;
        return [
          { x: margin, y: top, width: leftWidth, height },
          ...column(margin + leftWidth + gap, rightWidth, [1, 1, 1, 1])
        ];
      }
      if (layout.id === 'six') {
        const r = rows([1.2, 1]);
        return [...row(r[0].y, r[0].height, [1.7, 1, 1]), ...row(r[1].y, r[1].height, [1, 1, 1])];
      }
      if (layout.id === 'six-grid') {
        const r = rows([1, 1, 1]);
        return r.flatMap((item) => row(item.y, item.height, [1, 1]));
      }
      if (layout.id === 'six-grid-wide') return grid(2, 3);
      if (layout.id === 'six-side') {
        const usable = width - gap, leftWidth = usable * .52, rightWidth = usable - leftWidth;
        const rightRows = rows([1, 1]);
        return [
          { x: margin, y: top, width: leftWidth, height },
          ...row(rightRows[0].y, rightRows[0].height, [1, 1]).map((item) => ({ ...item, x: margin + leftWidth + gap + (item.x - margin) / width * rightWidth, width: item.width / width * rightWidth })),
          ...row(rightRows[1].y, rightRows[1].height, [1, 1, 1]).map((item) => ({ ...item, x: margin + leftWidth + gap + (item.x - margin) / width * rightWidth, width: item.width / width * rightWidth }))
        ];
      }
      if (layout.id === 'six-top') {
        const r = rows([1.55, 1, 1]);
        return [...row(r[0].y, r[0].height, [1]), ...row(r[1].y, r[1].height, [1, 1]), ...row(r[2].y, r[2].height, [1, 1, 1])];
      }
      if (layout.id === 'seven-feature') {
        const r = rows([1.55, 1, 1]);
        return [...row(r[0].y, r[0].height, [1]), ...row(r[1].y, r[1].height, [1, 1, 1]), ...row(r[2].y, r[2].height, [1, 1, 1])];
      }
      if (layout.id === 'seven-side') {
        const usable = width - gap, leftWidth = usable * .52, rightWidth = usable - leftWidth;
        return [
          { x: margin, y: top, width: leftWidth, height },
          ...column(margin + leftWidth + gap, rightWidth, [1, 1, 1, 1, 1, 1])
        ];
      }
      if (layout.id === 'eight-grid') {
        const r = rows([1, 1, 1, 1]);
        return r.flatMap((item) => row(item.y, item.height, [1, 1]));
      }
      if (layout.id === 'eight-grid-wide') return grid(2, 4);
      if (layout.id === 'eight-feature') {
        const r = rows([1.55, 1, 1]);
        return [...row(r[0].y, r[0].height, [1]), ...row(r[1].y, r[1].height, [1, 1, 1]), ...row(r[2].y, r[2].height, [1, 1, 1, 1])];
      }
      if (layout.id === 'eight-side') {
        const usable = width - gap, leftWidth = usable * .5, rightWidth = usable - leftWidth;
        return [
          { x: margin, y: top, width: leftWidth, height },
          ...column(margin + leftWidth + gap, rightWidth, [1, 1, 1, 1, 1, 1, 1])
        ];
      }
      if (layout.id === 'nine') {
        const r = rows([1.2, 1, 1]);
        return [...row(r[0].y, r[0].height, [1.65, 1]), ...row(r[1].y, r[1].height, [1, 1, 1]), ...row(r[2].y, r[2].height, [1, 1, 1, 1])];
      }
      if (layout.id === 'nine-grid') {
        const r = rows([1, 1, 1]);
        return r.flatMap((item) => row(item.y, item.height, [1, 1, 1]));
      }
      if (layout.id === 'ten-grid') return grid(5, 2);
      if (layout.id === 'ten-wide') return grid(2, 5);
      if (layout.id === 'ten-feature') {
        const r = rows([1.45, 1, 1, 1]);
        return [...row(r[0].y, r[0].height, [1]), ...r.slice(1).flatMap((item) => row(item.y, item.height, [1, 1, 1]))];
      }
      if (layout.id === 'twelve-grid') {
        const r = rows([1, 1, 1, 1]);
        return r.flatMap((item) => row(item.y, item.height, [1, 1, 1]));
      }
      if (layout.id === 'fifteen-grid') return grid(5, 3);
      if (layout.id === 'sixteen-grid') return grid(4, 4);
      if (layout.id === 'twenty-grid') return grid(5, 4);
      const r = rows([1.25, 1, 1, 1]);
      return [...row(r[0].y, r[0].height, [1.75, 1, 1]), ...r.slice(1).flatMap((item) => row(item.y, item.height, [1, 1, 1]))];
    };
    const a3Photos = (design) => design?.collage ? design.collage.photos.slice(0, a3Layout(design.collage.layout).count) : [];
    const a3Complete = (design) => Boolean(design?.collage && a3Photos(design).length === a3Layout(design.collage.layout).count && a3Photos(design).every((photo) => photo.image));
    const syncA3SavedSummary = () => {
      const frames = designSlots().filter((slot) => isCollageProduct(slot.category));
      designSavedBars.forEach((bar, category) => {
        const categorySlots = frames.filter((slot) => slot.category === category);
        const complete = categorySlots.filter((slot) => a3Complete(slot.design)).length;
        const allSaved = categorySlots.length > 0 && complete === categorySlots.length;
        const name = category === 'mug' ? 'mug design' : category === 'frame' ? 'A3 frame design' : 'acrylic frame design';
        bar.hidden = complete === 0;
        if (!complete) return;
        bar.querySelector('[data-design-saved-title]').textContent = allSaved
          ? `✓ ${complete === 1 ? `${name} saved` : `All ${complete} ${name}s saved`}`
          : `✓ ${complete} of ${categorySlots.length} ${name}s saved`;
        bar.querySelector('[data-design-saved-copy]').textContent = allSaved
          ? 'Your photos and design are saved with this order. You can now add more gifts.'
          : 'This design is saved. You can add more gifts now or edit the remaining design.';
      });
      a3SaveShopping.hidden = !a3Complete(activeDesign());
    };
    const a3BlankPhoto = () => ({ image: null, imageUrl: '', sourceFile: null, zoom: 1, rotation: 0, panX: 0, panY: 0 });
    const a3PhotoGeometry = (photo, width, height) => {
      const quarterTurn = Math.abs(photo.rotation / 90) % 2 === 1;
      const iw = quarterTurn ? photo.image.height : photo.image.width;
      const ih = quarterTurn ? photo.image.width : photo.image.height;
      const scale = Math.max(width / iw, height / ih) * photo.zoom;
      return { scale, extraX: Math.max(0, (iw * scale - width) / 2), extraY: Math.max(0, (ih * scale - height) / 2) };
    };
    const drawA3Theme = (ctx, width, height, themeId, greeting, formatId = 'a3') => {
      const theme = a3Theme(themeId);
      ctx.fillStyle = theme.background; ctx.fillRect(0, 0, width, height);
      if (theme.id === 'clean') return;
      const format = collageFormats[formatId] || collageFormats.a3;
      const sx = width / format.widthMm, sy = height / format.heightMm;
      ctx.strokeStyle = theme.accent; ctx.lineWidth = Math.max(2, .75 * sx); ctx.strokeRect(6 * sx, 6 * sy, width - 12 * sx, height - 12 * sy);
      ctx.fillStyle = theme.accent;
      ctx.fillRect(10 * sx, 10 * sy, 18 * sx, 2.2 * sy);
      ctx.fillRect(width - 28 * sx, height - 12.2 * sy, 18 * sx, 2.2 * sy);
      ctx.fillStyle = theme.foreground; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      const title = (typeof greeting === 'string' ? greeting : theme.title).replace(/\s+/g, ' ').trim().slice(0, 60);
      if (title) {
        const maxWidth = width - 64 * sx, minimumSize = Math.max(16, width * 0.018);
        let fontSize = Math.max(22, width * 0.034);
        ctx.font = `${theme.weight || 800} ${fontSize}px ${theme.font}`;
        if ('letterSpacing' in ctx) ctx.letterSpacing = `${Math.max(1, width * .0015)}px`;
        while (ctx.measureText(title).width > maxWidth && fontSize > minimumSize) {
          fontSize = Math.max(minimumSize, fontSize - Math.max(1, width * 0.002));
          ctx.font = `${theme.weight || 800} ${fontSize}px ${theme.font}`;
        }
        ctx.fillText(title.toUpperCase(), width / 2, 24 * sy, maxWidth);
        if ('letterSpacing' in ctx) ctx.letterSpacing = '0px';
      }
      ctx.fillStyle = theme.accent;
      ctx.fillRect(48 * sx, 39 * sy, width - 96 * sx, Math.max(2, .7 * sy));
    };
    const mugSlotPath = (ctx, width, height, slot) => {
      const x = -width / 2, y = -height / 2;
      ctx.beginPath();
      if (slot.shape === 'ellipse') {
        ctx.ellipse(0, 0, width / 2, height / 2, 0, 0, Math.PI * 2);
      } else if (slot.shape === 'heart') {
        ctx.moveTo(0, height * .46);
        ctx.bezierCurveTo(-width * .12, height * .31, -width * .5, height * .09, -width * .5, -height * .18);
        ctx.bezierCurveTo(-width * .5, -height * .5, -width * .12, -height * .55, 0, -height * .28);
        ctx.bezierCurveTo(width * .12, -height * .55, width * .5, -height * .5, width * .5, -height * .18);
        ctx.bezierCurveTo(width * .5, height * .09, width * .12, height * .31, 0, height * .46);
      } else if (slot.shape === 'arch') {
        ctx.moveTo(x, height / 2);
        ctx.lineTo(x, -height * .08);
        ctx.bezierCurveTo(x, -height * .42, -width * .28, -height / 2, 0, -height / 2);
        ctx.bezierCurveTo(width * .28, -height / 2, width / 2, -height * .42, width / 2, -height * .08);
        ctx.lineTo(width / 2, height / 2);
        ctx.closePath();
      } else if (slot.shape === 'shield') {
        ctx.moveTo(0, height / 2);
        ctx.bezierCurveTo(-width * .18, height * .36, -width * .43, height * .13, -width * .46, -height * .13);
        ctx.lineTo(-width * .46, -height * .38);
        ctx.quadraticCurveTo(-width * .25, -height * .48, 0, -height / 2);
        ctx.quadraticCurveTo(width * .25, -height * .48, width * .46, -height * .38);
        ctx.lineTo(width * .46, -height * .13);
        ctx.bezierCurveTo(width * .43, height * .13, width * .18, height * .36, 0, height / 2);
        ctx.closePath();
      } else if (slot.shape === 'rectangle') {
        ctx.rect(x, y, width, height);
      } else {
        const radius = Math.min(width, height, (slot.radius || 1) * width / Math.max(1, slot.width));
        ctx.moveTo(x + radius, y);
        ctx.lineTo(width / 2 - radius, y); ctx.quadraticCurveTo(width / 2, y, width / 2, y + radius);
        ctx.lineTo(width / 2, height / 2 - radius); ctx.quadraticCurveTo(width / 2, height / 2, width / 2 - radius, height / 2);
        ctx.lineTo(x + radius, height / 2); ctx.quadraticCurveTo(x, height / 2, x, height / 2 - radius);
        ctx.lineTo(x, y + radius); ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
      }
    };
    const drawA3Collage = (ctx, width, height, design, editing = false, selected = -1) => {
      const format = collageFormat(design);
      ctx.clearRect(0, 0, width, height);
      if (format.id === 'mug') {
        ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, width, height);
        const template = mugThemeImageCache.get(design.collage.layout);
        if (template?.complete && template.naturalWidth) ctx.drawImage(template, 0, 0, width, height);
      } else {
        drawA3Theme(ctx, width, height, design.collage.theme || 'clean', a3Greeting(design), format.id);
      }
      ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
      a3Rects(design.collage.layout, design.collage.theme, format.id).forEach((rect, index) => {
        const x = rect.x * width / format.widthMm, y = rect.y * height / format.heightMm;
        const w = rect.width * width / format.widthMm, h = rect.height * height / format.heightMm;
        const photo = design.collage.photos[index];
        ctx.save();
        if (format.id === 'mug') {
          ctx.translate(x + w / 2, y + h / 2);
          ctx.rotate((rect.angle || 0) * Math.PI / 180);
          mugSlotPath(ctx, w, h, rect);
        } else {
          ctx.beginPath(); ctx.rect(x, y, w, h);
        }
        ctx.clip();
        if (photo?.image) {
          const { scale, extraX, extraY } = a3PhotoGeometry(photo, w, h);
          if (format.id !== 'mug') ctx.translate(x + w / 2, y + h / 2);
          ctx.translate(photo.panX * extraX, photo.panY * extraY);
          ctx.rotate(photo.rotation * Math.PI / 180);
          ctx.drawImage(photo.image, -photo.image.width * scale / 2, -photo.image.height * scale / 2, photo.image.width * scale, photo.image.height * scale);
        } else if (editing) {
          ctx.fillStyle = 'rgba(255,255,255,.72)';
          if (format.id === 'mug') ctx.fillRect(-w / 2, -h / 2, w, h); else ctx.fillRect(x, y, w, h);
          ctx.fillStyle = '#245f55'; ctx.font = `600 ${Math.max(12, width * (format.id === 'mug' ? 0.018 : 0.027))}px sans-serif`; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
          ctx.fillText(`Photo ${index + 1}`, format.id === 'mug' ? 0 : x + w / 2, format.id === 'mug' ? 0 : y + h / 2);
        }
        ctx.restore();
        if (editing && index === selected) {
          ctx.save(); ctx.strokeStyle = '#800b32'; ctx.lineWidth = Math.max(2, width * .004);
          if (format.id === 'mug') {
            ctx.translate(x + w / 2, y + h / 2); ctx.rotate((rect.angle || 0) * Math.PI / 180); mugSlotPath(ctx, w, h, rect); ctx.stroke();
          } else ctx.strokeRect(x, y, w, h);
          ctx.restore();
        }
      });
    };
    // End of pure A3 geometry helpers.
    const totalUnits = () => selectedItems().reduce((sum, item) => sum + item.quantity, 0);
    const discountPerSet = () => totalUnits() >= 3
      ? Number(root.dataset.threeItemDiscount || 0)
      : totalUnits() === 2 ? Number(root.dataset.twoItemDiscount || 0) : 0;
    const regularTotal = () => selectedItems().reduce((sum, item) => sum + item.price * item.quantity, 0);
    const discountTotal = () => discountPerSet();
    const pricedTotal = () => Math.max(0, regularTotal() - discountTotal());
    const pricingRule = () => totalUnits() >= 3 ? 'three_item_bundle' : totalUnits() === 2 ? 'two_item_combo' : 'single';

    const updatePrice = () => {
      const regular = regularTotal();
      const price = pricedTotal();
      quantity.value = String(Math.max(1, totalUnits()));
      totalPrice.textContent = price ? money(price) : '—';
      totalCentsValue.value = String(price);
      pricingRuleValue.value = pricingRule();
      bundleSummary.hidden = totalUnits() < 2;
      if (totalUnits() >= 2) {
        bundleName.textContent = totalUnits() >= 3 ? `${totalUnits()}-item bundle discount applied` : '2-item combo discount applied';
        regularPrice.textContent = money(regular);
        bundlePrice.textContent = money(price);
        bundleSaving.textContent = `You save ${money(regular - price)} automatically.`;
      }
    };

    const updateReview = () => {
      const customerName = form.elements.customer_name?.value || '';
      reviewProduct.textContent = selectedItems().length
        ? selectedItems().map((item) => `${item.quantity} × ${item.product} · ${item.widthCm} × ${item.heightCm} cm`).join(' + ')
        : '—';
      reviewQuantity.textContent = `${totalUnits()} item${totalUnits() === 1 ? '' : 's'}`;
      reviewCustomer.textContent = customerName || '—';
      reviewTotal.textContent = pricedTotal() ? money(pricedTotal()) : '—';
    };

    const pageHash = (index) => `fd-${pages[index].dataset.wizardPage}`;

    const showPage = (index, updateHistory = true) => {
      const target = Math.max(0, Math.min(index, pages.length - 1));
      const changePage = () => {
        confirmation.hidden = true;
        progress.hidden = false;
        mobileIntro.hidden = false;
        pages.forEach((page, pageIndex) => { page.hidden = pageIndex !== target; });
        pageLinks.forEach((link, pageIndex) => {
          link.disabled = pageIndex > furthestPage;
          if (pageIndex === target) link.setAttribute('aria-current', 'step');
          else link.removeAttribute('aria-current');
        });
        currentPage = target;
        if (target === 1) syncPhotoSetup();
        if (target === pages.length - 1) updateReview();
      };
      if (document.startViewTransition) document.startViewTransition(changePage);
      else changePage();
      if (updateHistory) history.pushState({ fathersStallPage: target }, '', `#${pageHash(target)}`);
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const returnToGiftSelectionFromA3 = () => {
      if (!a3Complete(activeDesign())) return;
      saveActiveTransform();
      const savedCategory = state.category;
      syncA3SavedSummary();
      setStatus('');
      showPage(0);
      requestAnimationFrame(() => {
        syncA3SavedSummary();
        const savedBar = designSavedBars.get(savedCategory);
        savedBar?.focus({ preventScroll: true });
        savedBar?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    };

    a3SaveShopping.addEventListener('click', returnToGiftSelectionFromA3);
    const openSavedDesign = (category) => {
      const designs = designSlots().filter((slot) => slot.category === category);
      const target = designs.find((slot) => !a3Complete(slot.design)) || designs[0];
      if (!target) return;
      furthestPage = Math.max(furthestPage, 1);
      activateCategory(target.key);
      showPage(1);
      requestAnimationFrame(() => {
        const destination = target.design.a3Configured ? photoWorkspace : a3Picker;
        destination.focus?.({ preventScroll: true });
        destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    };
    designSavedBars.forEach((bar, category) => {
      bar.querySelector('[data-edit-saved-design]').addEventListener('click', () => openSavedDesign(category));
    });

    const resetOrder = () => {
      form.reset();
      productCards.forEach((item) => item.setAttribute('aria-pressed', 'false'));
      productCardRows.forEach((row) => {
        row.dataset.selected = 'false';
        row.querySelector('.fathers-stall__card-quantity').hidden = true;
      });
      frameSizeWrap.hidden = true;
      state.items.clear();
      state.category = '';
      state.copyIndex = 0;
      state.product = '';
      state.widthCm = 0;
      state.heightCm = 0;
      state.price = 0;
      state.photoMode = '';
      a3DesignStageComplete = false;
      a3Picker.hidden = true;
      a3Editor.hidden = true;
      designSavedBars.forEach((bar) => { bar.hidden = true; });
      a3SaveShopping.hidden = true;
      productValue.value = '';
      productsValue.value = '';
      productQuantitiesValue.value = '';
      designProductsValue.value = '';
      pickupScheduleValue.value = '';
      simulators.forEach(({ element }) => { element.dataset.category = ''; });
      clearImage();
      updateSpec();
      updatePrice();
      furthestPage = 0;
    };

    const paymentMethod = () => paymentMethodInputs.find((input) => input.checked)?.value || 'shopify';
    const syncPaymentChoice = () => {
      const counter = paymentMethod() === 'counter';
      submit.textContent = counter ? root.dataset.submitCounter : root.dataset.submitOnline;
    };

    const showConfirmation = (orderReference, customerEmail, method = 'shopify') => {
      pages.forEach((page) => { page.hidden = true; });
      progress.hidden = true;
      mobileIntro.hidden = true;
      confirmationOrderNumber.textContent = orderReference;
      const counter = method === 'counter';
      confirmationCopy.textContent = counter ? root.dataset.confirmationCounterCopy : root.dataset.confirmationCopy;
      confirmationEmail.textContent = (counter ? root.dataset.confirmationCounterEmail : root.dataset.confirmationEmailSent).replace('__email__', customerEmail);
      confirmationStatus.textContent = counter ? root.dataset.confirmationCounterStatus : root.dataset.confirmationStatus;
      confirmation.hidden = false;
      history.pushState({ fathersStallComplete: true }, '', '#fd-confirmation');
      confirmation.focus({ preventScroll: true });
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    shopMore.addEventListener('click', () => {
      showPage(0);
      root.querySelector('[data-product-card]')?.focus({ preventScroll: true });
    });
    paymentMethodInputs.forEach((input) => input.addEventListener('change', syncPaymentChoice));
    syncPaymentChoice();

    const validateCurrentPage = () => {
      if (a3Loading) { setStatus('Please wait for your collage photos to finish loading.', 'error'); return false; }
      if (currentPage === 0 && !state.items.size) {
        setStatus(root.dataset.productRequired, 'error');
        return false;
      }
      if (currentPage === 1) {
        if (designSlots().length > 1 && !state.photoMode) {
          setStatus(root.dataset.photoChoiceRequired, 'error');
          photoModeInputs[0]?.focus();
          return false;
        }
        const missingItems = designSlots().filter((slot) => !slot.design.image);
        if (missingItems.length) {
          const message = state.photoMode === 'different'
            ? root.dataset.photosMissing.replace('__products__', missingItems.map((slot) => slot.label).join(', '))
            : root.dataset.imageRequired;
          setStatus(message, 'error');
          activateCategory(missingItems[0].key);
          return false;
        }
      }
      const requiredFields = [...pages[currentPage].querySelectorAll('[required]')];
      const invalidField = requiredFields.find((field) => !field.checkValidity());
      if (invalidField) {
        invalidField.reportValidity();
        return false;
      }
      setStatus('');
      return true;
    };

    root.querySelectorAll('[data-next]').forEach((button) => button.addEventListener('click', () => {
      if (!validateCurrentPage()) return;
      furthestPage = Math.max(furthestPage, currentPage + 1);
      showPage(currentPage + 1);
    }));
    root.querySelectorAll('[data-back]').forEach((button) => button.addEventListener('click', () => showPage(currentPage - 1)));
    pageLinks.forEach((link) => link.addEventListener('click', () => {
      const target = Number(link.dataset.pageLink);
      if (target <= furthestPage) showPage(target);
    }));
    window.addEventListener('popstate', (event) => {
      const hashIndex = pages.findIndex((page) => `#fd-${page.dataset.wizardPage}` === location.hash);
      const target = Number.isInteger(event.state?.fathersStallPage) ? event.state.fathersStallPage : hashIndex;
      if (target >= 0 && target <= furthestPage) showPage(target, false);
    });
    history.replaceState({ fathersStallPage: 0 }, '', `${location.pathname}${location.search}`);

    const updateSpec = () => {
      productSpec.textContent = state.items.size
        ? selectedItems().map((item) => `${item.product}: ${item.widthCm} × ${item.heightCm} cm · 300 DPI · sRGB`).join('  |  ')
        : root.dataset.specPrompt;
    };

    const outputPixels = () => ({
      width: Math.max(1, Math.round((state.widthCm / 2.54) * 300)),
      height: Math.max(1, Math.round((state.heightCm / 2.54) * 300))
    });

    const rotatedSize = (image, rotation) => {
      const quarterTurn = Math.abs(rotation / 90) % 2 === 1;
      return { width: quarterTurn ? image.height : image.width, height: quarterTurn ? image.width : image.height };
    };

    const drawImageLayer = (targetContext, width, height, mode, applyOffset) => {
      if (!state.image) return;
      const rotated = rotatedSize(state.image, state.rotation);
      const baseScale = mode === 'cover' || mode === 'fill'
        ? Math.max(width / rotated.width, height / rotated.height)
        : Math.min(width / rotated.width, height / rotated.height);
      const scale = baseScale * (mode === 'foreground' || mode === 'fill' ? state.zoom : 1);
      const drawWidth = state.image.width * scale;
      const drawHeight = state.image.height * scale;
      const xOffset = applyOffset ? (state.offsetX / canvas.width) * width : 0;
      const yOffset = applyOffset ? (state.offsetY / canvas.height) * height : 0;
      targetContext.save();
      targetContext.translate(width / 2 + xOffset, height / 2 + yOffset);
      targetContext.rotate((state.rotation * Math.PI) / 180);
      targetContext.drawImage(state.image, -drawWidth / 2, -drawHeight / 2, drawWidth, drawHeight);
      targetContext.restore();
    };

    const drawArtwork = (targetContext, width, height, showSafeArea = false) => {
      if (isCollageProduct(state.category) && activeDesign()?.collage) {
        drawA3Collage(targetContext, width, height, activeDesign(), showSafeArea);
        return;
      }
      targetContext.clearRect(0, 0, width, height);
      targetContext.fillStyle = '#ffffff';
      targetContext.fillRect(0, 0, width, height);
      if (!state.image) return;
      const activeFitMode = state.category === 'tumbler' ? 'fill' : fitMode.value;
      if (activeFitMode === 'extend') {
        drawImageLayer(targetContext, width, height, 'foreground', true);
      } else {
        drawImageLayer(targetContext, width, height, 'fill', true);
      }
      if (showSafeArea) {
        const inset = Math.max(9, Math.round(Math.min(width, height) * 0.055));
        targetContext.save();
        targetContext.strokeStyle = 'rgba(255,255,255,.95)';
        targetContext.lineWidth = 2;
        targetContext.setLineDash([8, 6]);
        targetContext.strokeRect(inset, inset, width - inset * 2, height - inset * 2);
        targetContext.restore();
      }
    };

    const resizePreviewCanvas = () => {
      if (!state.widthCm || !state.heightCm) return;
      const maxWidth = Math.min(680, canvasWrap.clientWidth || 680);
      const maxHeight = 440;
      const ratio = state.widthCm / state.heightCm;
      let width = maxWidth;
      let height = width / ratio;
      if (height > maxHeight) {
        height = maxHeight;
        width = height * ratio;
      }
      canvas.width = Math.max(180, Math.round(width));
      canvas.height = Math.max(180, Math.round(height));
    };

    const buildCylinder = (surface, imageUrl, category) => {
      const segments = category === 'mug' ? 56 : 52;
      const radius = category === 'mug' ? 102 : 62;
      const panelWidth = ((Math.PI * 2 * radius) / segments) + 0.45;
      const textureWidth = panelWidth * segments;
      surface.replaceChildren();
      surface.style.removeProperty('background-image');
      const fragment = document.createDocumentFragment();
      for (let index = 0; index < segments; index += 1) {
        const angle = (index / segments) * 360;
        // Put the centre of the customer's wrap on the front-facing half of the
        // product. The left/right join is then hidden at the back at 0 degrees.
        const textureIndex = (index + Math.floor(segments / 2)) % segments;
        const panel = document.createElement('span');
        panel.className = 'fathers-stall__mockup-panel';
        panel.dataset.panelAngle = String(angle);
        panel.style.setProperty('--panel-width', `${panelWidth}px`);
        panel.style.setProperty('--panel-angle', `${angle}deg`);
        panel.style.width = `${panelWidth + 0.7}px`;
        panel.style.backgroundImage = `url(${JSON.stringify(imageUrl)})`;
        panel.style.backgroundSize = `${textureWidth}px 100%`;
        panel.style.backgroundPosition = `${-textureIndex * panelWidth}px 0`;
        fragment.append(panel);
      }
      surface.append(fragment);
      surface.dataset.cylinderCategory = category;
      surface.dataset.cylinderImage = imageUrl;
    };

    const setPreviewRotation = (value) => {
      const limit = state.category === 'frame' || state.category === 'ledframe' || state.category.startsWith('magnet') || state.category === 'acrylicframe' || state.category === 'woodcircle' ? 55 : 180;
      state.previewRotation = Math.max(-limit, Math.min(limit, Number(value) || 0));
      const design = activeDesign();
      if (design) design.previewRotation = state.previewRotation;
      const productTurn = state.previewRotation;
      simulators.forEach(({ product, surface, rotation }) => {
        product.style.setProperty('--product-turn', `${productTurn}deg`);
        product.style.setProperty('--detail-counter-turn', `${-productTurn}deg`);
        surface.querySelectorAll('[data-panel-angle]').forEach((panel) => {
          const facing = Math.cos(((Number(panel.dataset.panelAngle) + productTurn) * Math.PI) / 180);
          const brightness = 0.62 + Math.max(0, facing) * 0.38;
          panel.style.filter = `brightness(${brightness})`;
        });
        rotation.min = String(-limit);
        rotation.max = String(limit);
        rotation.value = String(state.previewRotation);
      });
    };

    const updateProductSimulators = (imageUrl = '') => {
      simulators.forEach(({ element, surface, message, controls, help }) => {
        element.dataset.category = state.category;
        const mugPrintNote = element.querySelector('[data-mug-print-note]');
        if (mugPrintNote) mugPrintNote.hidden = state.category !== 'mug' || !imageUrl;
        if (imageUrl) {
          if (state.category === 'frame' || state.category === 'ledframe' || state.category.startsWith('magnet') || state.category === 'acrylicframe' || state.category === 'woodcircle') {
            surface.replaceChildren();
            surface.style.backgroundImage = `url(${JSON.stringify(imageUrl)})`;
            delete surface.dataset.cylinderCategory;
            delete surface.dataset.cylinderImage;
          } else if (surface.dataset.cylinderCategory !== state.category || surface.dataset.cylinderImage !== imageUrl) {
            buildCylinder(surface, imageUrl, state.category);
          }
          message.hidden = true;
          controls.hidden = false;
          help.hidden = false;
          element.classList.remove('fathers-stall__mockup--empty');
        } else {
          surface.replaceChildren();
          surface.style.removeProperty('background-image');
          delete surface.dataset.cylinderCategory;
          delete surface.dataset.cylinderImage;
          message.hidden = false;
          controls.hidden = true;
          help.hidden = true;
          element.classList.add('fathers-stall__mockup--empty');
        }
      });
      setPreviewRotation(state.previewRotation);
    };

    const render = () => {
      syncZoomControl(zoom);
      cancelAnimationFrame(renderFrame);
      renderFrame = requestAnimationFrame(() => {
        resizePreviewCanvas();
        drawArtwork(context, canvas.width, canvas.height, true);
        if (state.image) {
          simulatorCanvas.width = canvas.width;
          simulatorCanvas.height = canvas.height;
          drawArtwork(simulatorContext, simulatorCanvas.width, simulatorCanvas.height, false);
          const previewUrl = simulatorCanvas.toDataURL('image/jpeg', 0.9);
          const design = activeDesign();
          if (design) design.previewUrl = previewUrl;
          updateProductSimulators(previewUrl);
        } else {
          updateProductSimulators();
        }
      });
    };

    const resetImagePosition = () => {
      state.rotation = 0;
      state.zoom = 1;
      state.offsetX = 0;
      state.offsetY = 0;
      zoom.value = '1';
      const design = activeDesign();
      if (design) Object.assign(design, { rotation: 0, zoom: 1, offsetXRatio: 0, offsetYRatio: 0 });
      render();
    };

    const clearImage = () => {
      if (state.photoMode === 'shared') {
        designSlots().forEach((slot) => Object.assign(slot.design, { image: null, imageUrl: '', sourceFile: null }));
      } else {
        const design = activeDesign();
        if (design) Object.assign(design, { image: null, imageUrl: '', sourceFile: null });
      }
      state.image = null;
      state.imageUrl = '';
      imageInput.value = '';
      editor.hidden = true;
      resetImagePosition();
      updatePhotoProgress();
    };

    const saveActiveTransform = () => {
      const design = activeDesign();
      if (!design || design.collage) return;
      Object.assign(design, {
        rotation: state.rotation,
        zoom: state.zoom,
        fitMode: state.category === 'tumbler' ? 'fill' : fitMode.value,
        offsetXRatio: canvas.width ? state.offsetX / canvas.width : 0,
        offsetYRatio: canvas.height ? state.offsetY / canvas.height : 0
      });
    };

    const applyActiveProduct = (source, category, copyIndex = 0, saveCurrent = true) => {
      if (saveCurrent) saveActiveTransform();
      state.category = category;
      state.copyIndex = copyIndex;
      state.product = source.dataset.product || source.value;
      state.widthCm = Number(source.dataset.width);
      state.heightCm = Number(source.dataset.height);
      state.price = Number(source.dataset.price);
      simulators.forEach(({ element }) => { element.dataset.category = category; });
      const design = activeDesign();
      state.image = design?.image ?? null;
      state.imageUrl = design?.imageUrl ?? '';
      state.rotation = design?.rotation ?? 0;
      state.zoom = design?.zoom ?? 1;
      state.previewRotation = design?.previewRotation ?? 0;
      fitMode.value = category === 'tumbler' ? 'fill' : (design?.fitMode ?? 'extend');
      fitMode.disabled = category === 'tumbler';
      zoom.value = String(state.zoom);
      resizePreviewCanvas();
      state.offsetX = (design?.offsetXRatio ?? 0) * canvas.width;
      state.offsetY = (design?.offsetYRatio ?? 0) * canvas.height;
      imageInput.value = '';
      editor.hidden = !state.image;
      updatePhotoProgress();
      render();
    };

    const sourceItem = (source, category) => ({
      category,
      variantId: Number(source.dataset.variantId || productCards.find((card) => card.dataset.category === category)?.dataset.variantId),
      product: source.dataset.product || source.value,
      widthCm: Number(source.dataset.width),
      heightCm: Number(source.dataset.height),
      price: Number(source.dataset.price),
      pickup: source.dataset.pickup || 'same_day',
      photosPerUnit: Math.max(1, Number(source.dataset.photosPerUnit || 1)),
      quantity: 1,
      copies: [],
      image: null,
      imageUrl: '',
      sourceFile: null,
      rotation: 0,
      zoom: 1,
      fitMode: category === 'tumbler' ? 'fill' : 'extend',
      previewRotation: 0,
      previewUrl: '',
      offsetXRatio: 0,
      offsetYRatio: 0,
      a3Configured: !isCollageProduct(category)
    });

    const clearAllPhotoAssignments = () => {
      designSlots().filter((slot) => !slot.design.collage).forEach((slot) => Object.assign(slot.design, {
        image: null,
        imageUrl: '',
        sourceFile: null,
        rotation: 0,
        zoom: 1,
        offsetXRatio: 0,
        offsetYRatio: 0
      }));
      state.image = null;
      state.imageUrl = '';
      imageInput.value = '';
      editor.hidden = true;
      render();
    };

    const validatePhotoFile = (file) => {
      if (file.size > maxBytes) return root.dataset.fileTooLarge;
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return root.dataset.fileTypeError;
      return '';
    };

    const loadPhotoFile = (file) => new Promise((resolve, reject) => {
      const imageUrl = URL.createObjectURL(file);
      const image = new Image();
      image.onload = () => resolve({ image, imageUrl, sourceFile: file });
      image.onerror = () => {
        URL.revokeObjectURL(imageUrl);
        reject(new Error(root.dataset.fileTypeError));
      };
      image.src = imageUrl;
    });

    const assignPhotoToDesign = (design, image, imageUrl, category, sourceFile) => Object.assign(design, {
      image,
      imageUrl,
      sourceFile,
      rotation: 0,
      zoom: 1,
      fitMode: category === 'tumbler' ? 'fill' : 'extend',
      previewRotation: 0,
      previewUrl: '',
      offsetXRatio: 0,
      offsetYRatio: 0
    });

    const invalidateA3Approval = () => {
      const approval = form.querySelector('[name="design_confirmed"]');
      if (approval) approval.checked = false;
      furthestPage = Math.min(furthestPage, 2);
      pageLinks.forEach((link, index) => { link.disabled = index > furthestPage; });
    };
    const refreshA3Composition = (design) => {
      if (!design?.collage) return;
      const format = collageFormat(design);
      const preview = design.collage.preview || document.createElement('canvas');
      preview.width = 500; preview.height = Math.round(500 * format.heightMm / format.widthMm);
      drawA3Collage(preview.getContext('2d'), preview.width, preview.height, design);
      design.collage.preview = preview;
      design.image = a3Complete(design) ? preview : null;
      design.imageUrl = ''; design.previewUrl = '';
      if (activeDesign() === design) state.image = design.image;
    };
    const setA3Layout = (design, id) => {
      if (!design || a3Loading) return;
      const slot = designSlots().find((candidate) => candidate.design === design);
      const category = slot?.category || state.category;
      const allowedLayouts = collageLayoutsForCategory(category);
      if (!allowedLayouts.some((layout) => layout.id === id)) return;
      const needsThemedAcrylicSingle = category === 'acrylicframe' && id === 'single' && !design.collage;
      if (!needsThemedAcrylicSingle && (design.collage?.layout || 'single') === id) {
        design.a3Configured = true;
        syncA3Picker();
        return;
      }
      saveActiveTransform();
      if (id === 'single' && category !== 'acrylicframe') {
        design.savedCollage = design.collage;
        design.collage = null;
        Object.assign(design, design.singlePhoto || blankDesign(category));
      } else {
        if (!design.collage) {
          const singleKeys = Object.keys(blankDesign(category));
          design.singlePhoto = Object.fromEntries(singleKeys.map((key) => [key, design[key]]));
          design.collage = design.savedCollage || { layout: id, theme: 'clean', title: '', titleCustomized: false, photos: [] };
          if (!design.collage.photos.length && design.image) {
            design.collage.photos.push({ ...a3BlankPhoto(), image: design.image, imageUrl: design.imageUrl, sourceFile: design.sourceFile });
          }
        }
        design.collage.format = collageFormatId(category);
        design.collage.layout = a3Layout(id).id;
        design.collage.theme = a3Theme(design.collage.theme).id;
        if (typeof design.collage.title !== 'string') design.collage.title = a3Theme(design.collage.theme).title;
        design.collage.titleCustomized = design.collage.titleCustomized === true;
        while (design.collage.photos.length < a3Layout(id).count) design.collage.photos.push(a3BlankPhoto());
        Object.assign(design, { rotation: 0, zoom: 1, fitMode: 'fill', offsetXRatio: 0, offsetYRatio: 0 });
        refreshA3Composition(design);
      }
      design.a3Configured = true;
      a3SelectedPhoto = 0;
      invalidateA3Approval();
      if (slot) activateCategory(slot.key, false);
      syncSelection(); setStatus('');
    };
    const setA3Theme = (design, id) => {
      if (!design?.collage || a3Loading || (design.collage.theme || 'clean') === id) return;
      const nextTheme = a3Theme(id);
      design.collage.theme = nextTheme.id;
      if (!design.collage.titleCustomized) design.collage.title = nextTheme.title;
      refreshA3Composition(design); invalidateA3Approval(); syncA3Picker(); syncA3Editor(); render();
    };
    const setA3Title = (design, value) => {
      if (!design?.collage || a3Loading) return;
      design.collage.title = String(value || '').slice(0, 60);
      design.collage.titleCustomized = true;
      refreshA3Composition(design); invalidateA3Approval(); syncA3Picker(); syncA3Editor(); render();
    };
    const a3LayoutButtons = new Map();
    const a3EditLayoutOptions = new Map();
    const renderCollageMiniature = (miniature, layoutId, formatId = 'a3') => {
      const format = collageFormats[formatId] || collageFormats.a3;
      miniature.replaceChildren();
      miniature.style.aspectRatio = `${format.widthMm} / ${format.heightMm}`;
      const selectedMugTheme = format.id === 'mug' ? mugTheme(layoutId) : null;
      miniature.style.backgroundImage = selectedMugTheme?.asset ? `url("${selectedMugTheme.asset}")` : '';
      if (format.id === 'mug') {
        if (!selectedMugTheme?.asset) {
          const cell = document.createElement('span');
          Object.assign(cell.style, { inset: '0', background: 'linear-gradient(135deg, #d8e6e3, #b7d1cb 48%, #e8d8cc 49%, #d4b7a5)' });
          miniature.append(cell);
        }
        return;
      }
      a3Rects(layoutId, 'clean', format.id).forEach((rect) => {
        const cell = document.createElement('span');
        Object.assign(cell.style, { left: `${rect.x / format.widthMm * 100}%`, top: `${rect.y / format.heightMm * 100}%`, width: `${rect.width / format.widthMm * 100}%`, height: `${rect.height / format.heightMm * 100}%` });
        miniature.append(cell);
      });
    };
    allCollageLayoutChoices.forEach((layout) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'fathers-stall__collage-layout';
      button.dataset.a3Layout = layout.id; button.setAttribute('aria-pressed', 'false');
      const miniature = document.createElement('span'); miniature.className = 'fathers-stall__collage-mini'; miniature.setAttribute('aria-hidden', 'true');
      renderCollageMiniature(miniature, layout.id);
      const label = document.createElement('span'); label.textContent = layout.label;
      button.append(miniature, label); a3Layouts.append(button); a3LayoutButtons.set(layout.id, button);
      button.addEventListener('click', () => {
        const slot = designSlots().find((candidate) => candidate.key === a3FrameSelect.value);
        if (slot) setA3Layout(slot.design, layout.id);
      });
      const option = document.createElement('option'); option.value = layout.id; option.textContent = layout.label; a3EditLayout.append(option); a3EditLayoutOptions.set(layout.id, option);
    });
    const a3ThemeButtons = new Map();
    a3ThemeChoices.forEach((theme) => {
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'fathers-stall__theme-option'; button.dataset.a3Theme = theme.id; button.setAttribute('aria-pressed', 'false');
      button.textContent = theme.label;
      button.style.setProperty('--theme-bg', theme.background); button.style.setProperty('--theme-fg', theme.foreground); button.style.setProperty('--theme-accent', theme.accent);
      button.addEventListener('click', () => {
        const slot = designSlots().find((candidate) => candidate.key === a3FrameSelect.value);
        if (slot) setA3Theme(slot.design, theme.id);
      });
      a3Themes.append(button); a3ThemeButtons.set(theme.id, button);
      const option = document.createElement('option'); option.value = theme.id; option.textContent = theme.label; a3EditTheme.append(option);
    });
    const syncA3Picker = () => {
      const frames = designSlots().filter((slot) => isCollageProduct(slot.category));
      a3Picker.hidden = frames.length === 0 || a3DesignStageComplete || currentPage !== 1;
      const oldValue = a3FrameSelect.value;
      const activeKey = isCollageProduct(state.category) ? `${state.category}::${state.copyIndex}` : oldValue;
      a3FrameSelect.replaceChildren();
      frames.forEach((slot) => {
        const option = document.createElement('option'); option.value = slot.key; option.textContent = `${slot.item.product}${slot.item.quantity > 1 ? ` — ${slot.category === 'mug' ? 'Mug' : 'Frame'} ${slot.copyIndex + 1}` : ''}`; a3FrameSelect.append(option);
      });
      if (frames.some((slot) => slot.key === activeKey)) a3FrameSelect.value = activeKey;
      a3FrameChoice.hidden = frames.length < 2;
      const activeFrame = frames.find((slot) => slot.key === a3FrameSelect.value);
      const design = activeFrame?.design;
      const category = activeFrame?.category || state.category;
      const format = collageFormat(design, category);
      const allowedIds = new Set(collageLayoutsForCategory(category).map((layout) => layout.id));
      const isAcrylic = category === 'acrylicframe';
      const isMug = category === 'mug';
      a3Picker.dataset.category = category;
      collagePickerEyebrow.textContent = isMug ? '11 OZ MUG DESIGN' : isAcrylic ? '12 × 15 ACRYLIC FRAME DESIGN' : 'A3 FRAME DESIGN';
      collagePickerHeading.textContent = isMug ? 'Choose your mug design' : isAcrylic ? 'Choose a theme and personalised wording' : 'Choose your collage, theme and wording';
      collagePickerCopy.textContent = isMug
        ? 'Choose Plain photo mug for one full-wrap photo, or select a Father’s Day theme. Each design shows exactly how many photos you can select together on the next screen.'
        : isAcrylic
        ? 'Your acrylic frame uses one full-size photo. Select the single-photo option, then choose a Father’s Day theme and edit the wording.'
        : 'Select a layout first. The number on each option is the exact number of photos you can upload together on the next screen.';
      collagePickerSpec.textContent = isMug
        ? '11 oz mug wrap · 21.5 × 9.6 cm · final print artwork is prepared at 2539 × 1134 px (300 DPI)'
        : isAcrylic
        ? '12 × 15 in · 30.48 × 38.1 cm · one full-size photo · final artwork is prepared at 300 DPI'
        : 'A3 portrait · 29.7 × 42 cm · all layouts print as one borderless A3 artwork';
      a3Picker.setAttribute('aria-label', `${format.label} design`);
      a3LayoutButtons.forEach((button, id) => {
        const allowed = allowedIds.has(id);
        button.hidden = !allowed;
        button.setAttribute('aria-pressed', String(allowed && (design?.collage?.layout || 'single') === id));
        button.disabled = a3Loading || !allowed;
        if (allowed) renderCollageMiniature(button.querySelector('.fathers-stall__collage-mini'), id, format.id);
      });
      a3ThemePicker.hidden = isMug || !design;
      a3Themes.hidden = isMug || !design?.collage;
      a3ThemeGuidance.hidden = isMug || Boolean(design?.collage);
      a3ThemeNote.hidden = isMug || !design?.collage;
      a3ThemeButtons.forEach((button, id) => { button.setAttribute('aria-pressed', String((design?.collage?.theme || 'clean') === id)); button.disabled = a3Loading; });
      const hasGreeting = Boolean(!isMug && design?.collage && a3Theme(design.collage.theme).id !== 'clean');
      a3TitleWrap.hidden = !hasGreeting;
      a3Title.value = hasGreeting ? (typeof design.collage.title === 'string' ? design.collage.title : a3Theme(design.collage.theme).title) : '';
      a3Title.disabled = a3Loading;
      const allConfigured = frames.length > 0 && frames.every((slot) => slot.design.a3Configured);
      const currentConfigured = Boolean(design?.a3Configured);
      a3DesignContinue.disabled = !currentConfigured || a3Loading;
      a3DesignContinue.textContent = !currentConfigured
        ? (isMug ? 'Choose a mug design to continue' : 'Choose a collage to continue')
        : allConfigured
          ? 'Continue to upload photos'
          : `Save and design next ${isMug ? 'mug' : 'frame'}`;
    };
    const hideA3PhotoAction = () => { a3PhotoAction.hidden = true; };
    const showA3PhotoAction = (index) => {
      const design = activeDesign();
      const photo = a3Photos(design)[index];
      if (!photo?.image) return;
      a3SelectedPhoto = index;
      a3PhotoActionLabel.textContent = `Photo ${index + 1} selected`;
      a3PhotoAction.hidden = false;
      syncA3Controls();
    };
    const cancelA3LongPress = () => {
      if (a3LongPressTimer) window.clearTimeout(a3LongPressTimer);
      a3LongPressTimer = 0;
    };
    const startA3LongPress = (index, suppressClick = true) => {
      cancelA3LongPress();
      a3LongPressTimer = window.setTimeout(() => {
        a3LongPressTimer = 0;
        if (suppressClick) a3SuppressClick = index;
        a3Drag = null;
        showA3PhotoAction(index);
      }, 550);
    };
    const removeA3SelectedPhoto = () => {
      const design = activeDesign();
      const photo = a3Photos(design)[a3SelectedPhoto];
      if (!photo?.image || a3Loading) return;
      Object.assign(photo, a3BlankPhoto());
      refreshA3Composition(design);
      invalidateA3Approval();
      hideA3PhotoAction();
      updatePhotoProgress();
    };
    const syncA3Controls = () => {
      const design = activeDesign();
      const photos = a3Photos(design);
      const photo = photos[a3SelectedPhoto];
      root.querySelector('[data-a3-selected]').textContent = `Photo ${a3SelectedPhoto + 1} of ${photos.length}`;
      root.querySelector('[data-a3-replace]').textContent = photo?.image ? 'Replace photo' : 'Add photo';
      a3Zoom.value = String(photo?.zoom || 1); a3PanX.value = String(photo?.panX || 0); a3PanY.value = String(photo?.panY || 0);
      a3Crop.querySelectorAll('input, button').forEach((control) => { control.disabled = a3Loading || (!photo?.image && !control.hasAttribute('data-a3-replace')); });
      syncZoomControl(a3Zoom);
      [...a3Slots.children].forEach((button, index) => button.setAttribute('aria-pressed', String(index === a3SelectedPhoto)));
      if (design?.collage) drawA3Collage(a3Canvas.getContext('2d'), a3Canvas.width, a3Canvas.height, design, true, a3SelectedPhoto);
    };
    const syncA3Editor = () => {
      hideA3PhotoAction();
      syncA3Picker();
      const design = activeDesign(), isFrame = isCollageProduct(state.category), collage = isFrame && design?.collage;
      const format = collageFormat(design, state.category);
      const allowedIds = new Set(collageLayoutsForCategory(state.category).map((layout) => layout.id));
      const isMug = state.category === 'mug';
      a3Editor.hidden = !isFrame;
      a3Editor.setAttribute('aria-label', `${format.label} photo editor`);
      collageEditLayoutLabel.textContent = isMug ? 'Mug design' : 'Frame layout';
      root.querySelector('[data-single-upload]').hidden = Boolean(collage);
      editor.hidden = Boolean(collage) || !state.image;
      a3EditLayoutOptions.forEach((option, id) => { option.hidden = !allowedIds.has(id); option.disabled = !allowedIds.has(id); });
      a3EditLayout.value = collage?.layout || 'single'; a3EditLayout.disabled = a3Loading;
      a3EditThemeWrap.hidden = isMug || !collage;
      a3EditTheme.value = collage?.theme || 'clean'; a3EditTheme.disabled = a3Loading;
      const hasGreeting = Boolean(!isMug && collage && a3Theme(collage.theme).id !== 'clean');
      a3EditTitleWrap.hidden = !hasGreeting;
      a3EditTitle.value = hasGreeting ? (typeof collage.title === 'string' ? collage.title : a3Theme(collage.theme).title) : '';
      a3EditTitle.disabled = a3Loading;
      [a3Canvas, a3Slots, a3Batch, a3Crop, a3Progress].forEach((element) => { element.hidden = !collage; });
      if (!collage) return;
      a3Canvas.width = 500;
      a3Canvas.height = Math.round(500 * format.heightMm / format.widthMm);
      const photos = a3Photos(design), complete = photos.filter((photo) => photo.image).length;
      a3SelectedPhoto = Math.min(a3SelectedPhoto, photos.length - 1);
      const remaining = photos.length - complete;
      a3Progress.textContent = `${isMug ? 'Mug' : 'Frame'} ${state.copyIndex + 1} · ${complete} of ${photos.length} photos added. All photos print together as ${format.sheetLabel}.`;
      a3Batch.textContent = complete === photos.length
        ? `SELECT ${photos.length} NEW PHOTOS AT ONCE`
        : complete === 0
          ? `SELECT ALL ${photos.length} PHOTOS AT ONCE`
          : `SELECT REMAINING ${remaining} PHOTOS AT ONCE`;
      root.querySelector('[data-a3-batch-help]').textContent = complete === photos.length
        ? `Choose ${photos.length} new photos in one go, or select a numbered photo below to replace only that image.`
        : `Choose up to ${remaining} photos in one go. Each selected file fills the next available collage space.`;
      a3Batch.disabled = a3Loading;
      a3SaveShopping.textContent = `Save ${isMug ? 'mug design' : 'collage'} & add more gifts`;
      a3Slots.replaceChildren();
      photos.forEach((photo, index) => {
        const button = document.createElement('button'); button.type = 'button'; button.disabled = a3Loading;
        button.textContent = `${index + 1}${photo.image ? ' ✓' : ' +'}`;
        button.setAttribute('aria-label', `Photo ${index + 1}, ${photo.image ? 'edit photo' : 'add photo'}`);
        button.addEventListener('pointerdown', () => { if (photo.image) startA3LongPress(index); });
        ['pointerup', 'pointercancel', 'pointerleave'].forEach((event) => button.addEventListener(event, cancelA3LongPress));
        button.addEventListener('contextmenu', (event) => { if (!photo.image) return; event.preventDefault(); showA3PhotoAction(index); });
        button.addEventListener('click', () => {
          if (a3SuppressClick === index) { a3SuppressClick = -1; return; }
          hideA3PhotoAction();
          a3SelectedPhoto = index;
          syncA3Controls();
          if (!photo.image) chooseA3Photos(true);
        });
        a3Slots.append(button);
      });
      syncA3Controls();
      syncA3SavedSummary();
    };
    const chooseA3Photos = (batch) => {
      const design = activeDesign();
      if (!design?.collage || a3Loading) return;
      const photos = a3Photos(design);
      const missing = photos.map((photo, index) => photo.image ? -1 : index).filter((index) => index >= 0);
      const batchIndices = missing.length
        ? [a3SelectedPhoto, ...missing.filter((index) => index !== a3SelectedPhoto)].filter((index) => missing.includes(index))
        : photos.map((_, index) => index);
      a3UploadTarget = { design, collage: design.collage, layout: design.collage.layout,
        indices: batch ? batchIndices : [a3SelectedPhoto] };
      const input = batch ? a3Input : a3SingleInput;
      input.value = '';
      try {
        if (typeof input.showPicker === 'function') input.showPicker();
        else input.click();
      } catch (error) {
        input.click();
      }
    };
    a3FrameSelect.addEventListener('change', () => activateCategory(a3FrameSelect.value));
    a3DesignContinue.addEventListener('click', () => {
      const frames = designSlots().filter((slot) => isCollageProduct(slot.category));
      const activeFrame = frames.find((slot) => slot.key === a3FrameSelect.value);
      if (!activeFrame?.design.a3Configured) {
        setStatus(`Choose a ${activeFrame?.category === 'mug' ? 'mug design' : 'collage arrangement'} before continuing.`, 'error');
        return;
      }
      const nextFrame = frames.find((slot) => !slot.design.a3Configured);
      if (nextFrame) {
        a3FrameSelect.value = nextFrame.key;
        activateCategory(nextFrame.key);
        syncA3Picker();
        a3Picker.focus({ preventScroll: true });
        a3Picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      a3DesignStageComplete = true;
      setStatus('');
      syncPhotoSetup();
      photoWorkspace.focus?.({ preventScroll: true });
      photoWorkspace.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    a3EditLayout.addEventListener('change', () => setA3Layout(activeDesign(), a3EditLayout.value));
    a3EditTheme.addEventListener('change', () => setA3Theme(activeDesign(), a3EditTheme.value));
    a3Title.addEventListener('input', () => {
      const slot = designSlots().find((candidate) => candidate.key === a3FrameSelect.value);
      if (slot) setA3Title(slot.design, a3Title.value);
    });
    a3EditTitle.addEventListener('input', () => setA3Title(activeDesign(), a3EditTitle.value));
    a3Batch.addEventListener('click', () => chooseA3Photos(true));
    root.querySelector('[data-a3-replace]').addEventListener('click', () => {
      const design = activeDesign();
      const photo = a3Photos(design)[a3SelectedPhoto];
      const missingCount = a3Photos(design).filter((candidate) => !candidate.image).length;
      chooseA3Photos(!photo?.image && missingCount > 1);
    });
    const handleA3Input = async (input) => {
      const files = [...(input.files || [])], target = a3UploadTarget;
      if (!files.length || !target || a3Loading) return;
      if (files.length > target.indices.length) { setStatus(`Choose no more than ${target.indices.length} photos for this design.`, 'error'); return; }
      const fileError = files.map(validatePhotoFile).find(Boolean);
      if (fileError) { setStatus(fileError, 'error'); return; }
      const wasBlank = a3Photos(target.design).every((photo) => !photo.image);
      const autoReturnAfterSave = input === a3Input
        && totalUnits() === 1
        && isCollageProduct(selectedItems()[0]?.category)
        && wasBlank
        && files.length === target.indices.length;
      let completedNow = false;
      a3Loading = true; syncA3Editor(); setStatus('Loading collage photos…');
      try {
        const results = await Promise.allSettled(files.map(loadPhotoFile));
        const error = results.find((result) => result.status === 'rejected');
        const stillSelected = designSlots().some((slot) => slot.design === target.design) && target.design.collage === target.collage && target.collage.layout === target.layout;
        if (error || !stillSelected) {
          results.forEach((result) => { if (result.status === 'fulfilled') URL.revokeObjectURL(result.value.imageUrl); });
          throw new Error(error ? root.dataset.fileTypeError : 'The selected design changed. Please choose the photos again.');
        }
        results.forEach((result, index) => { target.collage.photos[target.indices[index]] = { ...a3BlankPhoto(), ...result.value }; });
        refreshA3Composition(target.design); invalidateA3Approval();
        completedNow = a3Complete(target.design);
        if (activeDesign() === target.design) a3SelectedPhoto = target.indices[0];
        setStatus(''); render();
      } catch (error) { setStatus(error instanceof Error ? error.message : root.dataset.fileTypeError, 'error'); }
      finally { a3Loading = false; input.value = ''; a3UploadTarget = null; updatePhotoProgress(); }
      if (autoReturnAfterSave && completedNow) returnToGiftSelectionFromA3();
    };
    a3Input.addEventListener('change', () => handleA3Input(a3Input));
    a3SingleInput.addEventListener('change', () => handleA3Input(a3SingleInput));
    const editA3Photo = (change) => {
      const design = activeDesign(), photo = a3Photos(design)[a3SelectedPhoto];
      if (!photo?.image || a3Loading) return;
      change(photo); refreshA3Composition(design); invalidateA3Approval(); syncA3Controls(); render();
    };
    a3Zoom.addEventListener('input', () => editA3Photo((photo) => { photo.zoom = Number(a3Zoom.value); }));
    a3PanX.addEventListener('input', () => editA3Photo((photo) => { photo.panX = Number(a3PanX.value); }));
    a3PanY.addEventListener('input', () => editA3Photo((photo) => { photo.panY = Number(a3PanY.value); }));
    root.querySelector('[data-a3-rotate]').addEventListener('click', () => editA3Photo((photo) => { photo.rotation = (photo.rotation + 90) % 360; photo.panX = 0; photo.panY = 0; }));
    root.querySelector('[data-a3-reset]').addEventListener('click', () => editA3Photo((photo) => Object.assign(photo, { rotation: 0, zoom: 1, panX: 0, panY: 0 })));
    root.querySelector('[data-a3-remove]').addEventListener('click', removeA3SelectedPhoto);
    root.querySelector('[data-a3-hold-delete]').addEventListener('click', removeA3SelectedPhoto);
    root.querySelector('[data-a3-hold-cancel]').addEventListener('click', hideA3PhotoAction);
    const a3CanvasPhotoAt = (event, design = activeDesign()) => {
      if (!design?.collage) return null;
      const format = collageFormat(design, state.category);
      const bounds = a3Canvas.getBoundingClientRect();
      const x = (event.clientX - bounds.left) / bounds.width * format.widthMm;
      const y = (event.clientY - bounds.top) / bounds.height * format.heightMm;
      const rects = a3Rects(design.collage.layout, design.collage.theme, format.id);
      const index = rects.findIndex((rect) => x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height);
      return index < 0 ? null : { bounds, index, rects, format };
    };
    a3Canvas.addEventListener('pointerdown', (event) => {
      const design = activeDesign(); if (!design?.collage || a3Loading) return;
      const target = a3CanvasPhotoAt(event, design); if (!target) return;
      const { bounds, index, rects, format } = target;
      hideA3PhotoAction();
      a3SelectedPhoto = index; syncA3Controls();
      const photo = a3Photos(design)[index];
      if (!photo?.image) { chooseA3Photos(true); return; }
      startA3LongPress(index, false);
      const rect = rects[index];
      const geometry = a3PhotoGeometry(photo, rect.width / format.widthMm * bounds.width, rect.height / format.heightMm * bounds.height);
      a3Drag = { design, photo, x: event.clientX, y: event.clientY, panX: photo.panX, panY: photo.panY, ...geometry };
      // Pointer capture can be unavailable for synthetic events and on a few
      // mobile WebKit edge cases. Dragging still works without it, so do not
      // let a capture failure interrupt photo selection or replacement.
      try { a3Canvas.setPointerCapture(event.pointerId); } catch (error) {}
    });
    a3Canvas.addEventListener('pointermove', (event) => {
      if (!a3Drag || a3Drag.design !== activeDesign()) return;
      const drag = a3Drag;
      if (Math.hypot(event.clientX - drag.x, event.clientY - drag.y) > 8) cancelA3LongPress();
      editA3Photo((photo) => {
        photo.panX = drag.extraX ? Math.max(-1, Math.min(1, drag.panX + (event.clientX - drag.x) / drag.extraX)) : 0;
        photo.panY = drag.extraY ? Math.max(-1, Math.min(1, drag.panY + (event.clientY - drag.y) / drag.extraY)) : 0;
      });
    });
    a3Canvas.addEventListener('contextmenu', (event) => {
      const target = a3CanvasPhotoAt(event);
      if (!target || !a3Photos(activeDesign())[target.index]?.image) return;
      event.preventDefault();
      showA3PhotoAction(target.index);
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((event) => a3Canvas.addEventListener(event, () => { cancelA3LongPress(); a3Drag = null; }));

    const renderMagnetTemplates = () => {
      const magnetItems = selectedItems().filter((item) => item.photosPerUnit > 1);
      magnetTemplates.hidden = magnetItems.length === 0;
      magnetTemplates.innerHTML = '';
      magnetItems.forEach((item) => {
        for (let bundleIndex = 1; bundleIndex <= item.quantity; bundleIndex += 1) {
          const group = document.createElement('section');
          group.className = 'fathers-stall__magnet-template-group';
          const header = document.createElement('div');
          header.className = 'fathers-stall__magnet-template-header';
          const heading = document.createElement('strong');
          heading.textContent = `${item.photosPerUnit}-photo magnet bundle${item.quantity > 1 ? ` ${bundleIndex}` : ''}`;
          const grid = document.createElement('div');
          grid.className = 'fathers-stall__magnet-grid';
          grid.dataset.count = String(item.photosPerUnit);
          const bundleSlots = designSlots()
            .filter((slot) => slot.category === item.category && slot.bundleIndex === bundleIndex);
          const missingSlots = bundleSlots.filter((slot) => !slot.design.image);
          const batchButton = document.createElement('button');
          batchButton.type = 'button';
          batchButton.className = 'fathers-stall__magnet-batch-button';
          batchButton.textContent = missingSlots.length === 0
            ? `Replace all ${item.photosPerUnit} photos`
            : missingSlots.length === item.photosPerUnit
              ? `Choose up to ${item.photosPerUnit} photos`
              : `Add remaining ${missingSlots.length} photos`;
          batchButton.addEventListener('click', () => {
            magnetBatchInput.dataset.category = item.category;
            magnetBatchInput.dataset.bundleIndex = String(bundleIndex);
            magnetBatchInput.value = '';
            magnetBatchInput.click();
          });
          header.append(heading, batchButton);
          bundleSlots
            .forEach((slot) => {
              const button = document.createElement('button');
              button.type = 'button';
              button.className = 'fathers-stall__magnet-slot';
              button.dataset.complete = String(Boolean(slot.design.image));
              button.setAttribute('aria-current', String(slot.category === state.category && slot.copyIndex === state.copyIndex));
              button.setAttribute('aria-label', `${slot.label}${slot.design.image ? ', photo added' : ', upload photo'}`);
              if (slot.design.previewUrl || slot.design.imageUrl) {
                const image = document.createElement('img');
                image.src = slot.design.previewUrl || slot.design.imageUrl;
                image.alt = '';
                button.append(image);
              }
              const number = document.createElement('span');
              number.textContent = String(slot.photoIndex);
              button.append(number);
              const action = document.createElement('em');
              action.textContent = slot.design.image ? 'Change' : 'Add';
              button.append(action);
              button.addEventListener('click', () => {
                activateCategory(slot.key);
                imageInput.value = '';
                imageInput.click();
              });
              grid.append(button);
            });
          group.append(header, grid);
          magnetTemplates.append(group);
        }
      });
    };

    const updatePhotoProgress = () => {
      const slots = designSlots();
      const currentSlot = slots.find((slot) => slot.category === state.category && slot.copyIndex === state.copyIndex);
      if (state.photoMode === 'different' && slots.length > 1) {
        const complete = slots.filter((slot) => slot.design.image).length;
        photoProgress.textContent = root.dataset.photoProgress
          .replace('__complete__', String(complete))
          .replace('__total__', String(slots.length));
        photoProgress.hidden = false;
        const titleTemplate = currentSlot?.design.image ? root.dataset.photoReplaceFor : root.dataset.photoUploadFor;
        uploadTitle.textContent = titleTemplate.replace('__product__', currentSlot?.label || '');
      } else {
        photoProgress.hidden = true;
        uploadTitle.textContent = defaultUploadTitle;
      }
      renderMagnetTemplates();
      syncA3Editor();
    };

    const syncPhotoSetup = () => {
      const slots = designSlots();
      const frameSlots = slots.filter((slot) => isCollageProduct(slot.category));
      if (frameSlots.some((slot) => !slot.design.a3Configured)) a3DesignStageComplete = false;
      syncA3Picker();
      if (frameSlots.length && !a3DesignStageComplete) {
        state.photoMode = 'different';
        photoModeWrap.hidden = true;
        photoModeInputs.forEach((input) => {
          input.disabled = true;
          input.checked = input.value === 'different';
        });
        photoWorkspace.hidden = true;
        return;
      }
      const requiresIndividualPhotos = selectedItems().some((item) => item.photosPerUnit > 1) || slots.some((slot) => slot.design.collage);
      if (requiresIndividualPhotos) {
        state.photoMode = 'different';
        photoModeWrap.hidden = true;
        photoModeInputs.forEach((input) => {
          input.disabled = true;
          input.checked = input.value === 'different';
        });
        photoWorkspace.hidden = slots.length === 0;
      } else if (slots.length < 2) {
        photoModeWrap.hidden = true;
        photoModeInputs.forEach((input) => {
          input.disabled = true;
          input.checked = false;
        });
        state.photoMode = 'shared';
        photoWorkspace.hidden = slots.length === 0;
      } else {
        const isNewMultiProductChoice = photoModeWrap.hidden;
        photoModeWrap.hidden = false;
        photoModeInputs.forEach((input) => { input.disabled = false; });
        if (isNewMultiProductChoice) state.photoMode = '';
        photoModeInputs.forEach((input) => { input.checked = input.value === state.photoMode; });
        photoWorkspace.hidden = !state.photoMode;
      }
      updatePhotoProgress();
    };

    const updateSlotNavigation = () => {
      const slots = designSlots();
      const currentIndex = slots.findIndex((slot) => slot.category === state.category && slot.copyIndex === state.copyIndex);
      const currentSlot = slots[currentIndex];
      const showNavigation = slots.length > 1 && currentIndex >= 0;
      let counterText = '';
      if (currentSlot?.item.photosPerUnit > 1) {
        counterText = `Photo ${currentSlot.photoIndex} of ${currentSlot.item.photosPerUnit}`;
        if (currentSlot.item.quantity > 1) counterText += ` · Bundle ${currentSlot.bundleIndex} of ${currentSlot.item.quantity}`;
      } else if (showNavigation) {
        counterText = `Design ${currentIndex + 1} of ${slots.length}`;
      }
      slotNavigations.forEach(({ element, previous, next, counter }) => {
        element.hidden = !showNavigation;
        counter.textContent = counterText;
        previous.disabled = currentIndex <= 0;
        next.disabled = currentIndex < 0 || currentIndex >= slots.length - 1;
      });
    };

    const syncProductSelectors = () => {
      const slots = designSlots();
      [designProduct, previewProduct, reviewPreviewProduct].forEach((select) => {
        select.innerHTML = '';
        slots.forEach((slot) => {
          const option = document.createElement('option');
          option.value = slot.key;
          option.textContent = slots.length > selectedItems().length ? slot.label : slot.item.product;
          option.selected = slot.category === state.category && slot.copyIndex === state.copyIndex;
          select.append(option);
        });
      });
      designProductWrap.hidden = slots.length < 2;
      previewProductWrap.hidden = slots.length < 2;
      reviewPreviewProductWrap.hidden = slots.length < 2;
      updateSlotNavigation();
    };

    const syncSelection = () => {
      const items = selectedItems();
      syncDesignCopies();
      productValue.value = items.map((item) => item.product).join(' + ');
      productsValue.value = JSON.stringify(items.map((item) => item.product));
      productQuantitiesValue.value = JSON.stringify(Object.fromEntries(items.map((item) => [item.product, item.quantity])));
      designProductsValue.value = JSON.stringify(designSlots().map((slot) => slot.item.product));
      pickupScheduleValue.value = JSON.stringify(Object.fromEntries(items.map((item) => [item.product, item.pickup])));
      productCardRows.forEach((row, category) => {
        const item = state.items.get(category);
        row.dataset.selected = String(Boolean(item));
        const control = row.querySelector('.fathers-stall__card-quantity');
        control.hidden = !item;
        if (item) control.querySelector('[data-card-quantity]').value = String(item.quantity);
      });
      syncProductSelectors();
      updateSpec();
      updatePrice();
      syncPhotoSetup();
      syncA3SavedSummary();
      // A quantity decrease can change the active physical copy. Load that copy's
      // own artwork instead of keeping the removed copy in the global editor.
      if (state.items.has(state.category)) {
        const design = activeDesign();
        if (state.image !== design?.image) activateCategory(`${state.category}::${state.copyIndex}`);
      }
    };

    photoModeInputs.forEach((input) => input.addEventListener('change', () => {
      if (!input.checked || input.value === state.photoMode) return;
      state.photoMode = input.value;
      clearAllPhotoAssignments();
      photoWorkspace.hidden = false;
      const firstSlot = designSlots()[0];
      if (firstSlot) activateCategory(firstSlot.key);
      updatePhotoProgress();
      setStatus('');
    }));

    const activateCategory = (slotKey, saveCurrent = true) => {
      const [category, copyText = '0'] = String(slotKey).split('::');
      const copyIndex = Number(copyText) || 0;
      const item = state.items.get(category);
      if (!item) return;
      applyActiveProduct({ dataset: { product: item.product, width: item.widthCm, height: item.heightCm, price: item.price } }, category, copyIndex, saveCurrent);
      const value = `${category}::${copyIndex}`;
      designProduct.value = value;
      previewProduct.value = value;
      reviewPreviewProduct.value = value;
      updateSlotNavigation();
    };

    productCards.forEach((card) => card.addEventListener('click', () => {
      const category = card.dataset.category;
      const selecting = !state.items.has(category);
      card.setAttribute('aria-pressed', String(selecting));
      if (selecting && category.startsWith('magnet')) {
        productCards
          .filter((otherCard) => otherCard !== card && otherCard.dataset.category.startsWith('magnet'))
          .forEach((otherCard) => {
            state.items.delete(otherCard.dataset.category);
            otherCard.setAttribute('aria-pressed', 'false');
          });
      }
      if (selecting && category === 'frame') {
        const option = frameSize.selectedOptions[0];
        option.dataset.product = option.value;
        state.items.set('frame', sourceItem(option, 'frame'));
        applyActiveProduct(option, 'frame');
      } else if (selecting) {
        state.items.set(category, sourceItem(card, category));
        applyActiveProduct(card, category);
      } else {
        state.items.delete(category);
        if (state.category === category) {
          const fallback = selectedItems().at(-1);
          if (fallback) activateCategory(fallback.category);
          else {
            state.category = '';
            state.product = '';
            state.widthCm = 0;
            state.heightCm = 0;
            state.price = 0;
            simulators.forEach(({ element }) => { element.dataset.category = ''; });
          }
        }
      }
      frameSizeWrap.hidden = !state.items.has('frame');
      syncSelection();
      if (selecting && isCollageProduct(category)) {
        a3DesignStageComplete = false;
        furthestPage = Math.max(furthestPage, 1);
        showPage(1);
        requestAnimationFrame(() => {
          a3Picker.focus({ preventScroll: true });
          a3Picker.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }));

    frameSize.addEventListener('change', () => {
      const option = frameSize.selectedOptions[0];
      option.dataset.product = option.value;
      state.items.set('frame', sourceItem(option, 'frame'));
      applyActiveProduct(option, 'frame');
      syncSelection();
    });

    [designProduct, previewProduct, reviewPreviewProduct].forEach((select) => select.addEventListener('change', () => activateCategory(select.value)));
    slotNavigations.forEach(({ previous, next }) => {
      previous.addEventListener('click', () => {
        const slots = designSlots();
        const currentIndex = slots.findIndex((slot) => slot.category === state.category && slot.copyIndex === state.copyIndex);
        if (currentIndex > 0) activateCategory(slots[currentIndex - 1].key);
      });
      next.addEventListener('click', () => {
        const slots = designSlots();
        const currentIndex = slots.findIndex((slot) => slot.category === state.category && slot.copyIndex === state.copyIndex);
        if (currentIndex >= 0 && currentIndex < slots.length - 1) activateCategory(slots[currentIndex + 1].key);
      });
    });

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-card-quantity-minus], [data-card-quantity-plus]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      const row = button.closest('.fathers-stall__product-card-row');
      const input = row.querySelector('[data-card-quantity]');
      const delta = button.hasAttribute('data-card-quantity-plus') ? 1 : -1;
      const maxQuantity = Number(input.max || 20);
      input.value = String(Math.max(1, Math.min(maxQuantity, Number(input.value || 1) + delta)));
      const item = state.items.get(row.dataset.category);
      if (item) item.quantity = Number(input.value);
      const designCount = Number(input.value) * (item?.photosPerUnit || 1);
      if (state.category === row.dataset.category && state.copyIndex >= designCount) state.copyIndex = designCount - 1;
      syncSelection();
    });
    root.addEventListener('input', (event) => {
      const input = event.target.closest('[data-card-quantity]');
      if (!input) return;
      const row = input.closest('.fathers-stall__product-card-row');
      const maxQuantity = Number(input.max || 20);
      const value = Math.max(1, Math.min(maxQuantity, Number(input.value || 1)));
      input.value = String(value);
      const item = state.items.get(row.dataset.category);
      if (item) item.quantity = value;
      const designCount = value * (item?.photosPerUnit || 1);
      if (state.category === row.dataset.category && state.copyIndex >= designCount) state.copyIndex = designCount - 1;
      syncSelection();
    });

    magnetBatchInput.addEventListener('change', async () => {
      const files = [...(magnetBatchInput.files || [])];
      if (!files.length) return;
      const category = magnetBatchInput.dataset.category;
      const bundleIndex = Number(magnetBatchInput.dataset.bundleIndex || 1);
      const bundleSlots = designSlots().filter((slot) => slot.category === category && slot.bundleIndex === bundleIndex);
      const missingSlots = bundleSlots.filter((slot) => !slot.design.image);
      const targetSlots = missingSlots.length ? missingSlots : bundleSlots;
      if (files.length > targetSlots.length) {
        setStatus(`Choose no more than ${targetSlots.length} photo${targetSlots.length === 1 ? '' : 's'} for this bundle.`, 'error');
        magnetBatchInput.value = '';
        return;
      }
      const fileError = files.map(validatePhotoFile).find(Boolean);
      if (fileError) {
        setStatus(fileError, 'error');
        magnetBatchInput.value = '';
        return;
      }
      try {
        const loadedPhotos = await Promise.all(files.map(loadPhotoFile));
        loadedPhotos.forEach(({ image, imageUrl, sourceFile }, index) => {
          assignPhotoToDesign(targetSlots[index].design, image, imageUrl, category, sourceFile);
        });
        activateCategory(targetSlots[0].key);
        updatePhotoProgress();
        setStatus('');
      } catch (error) {
        setStatus(error instanceof Error ? error.message : root.dataset.fileTypeError, 'error');
      } finally {
        magnetBatchInput.value = '';
      }
    });

    imageInput.addEventListener('change', () => {
      const file = imageInput.files?.[0];
      if (!file) return clearImage();
      const fileError = validatePhotoFile(file);
      if (fileError) {
        clearImage();
        setStatus(fileError, 'error');
        return;
      }
      // Capture the intended physical item before decoding. Switching to a
      // collage while this image loads must not overwrite that collage.
      const targets = designSlots().filter((slot) => !slot.design.collage && (state.photoMode === 'shared' || slot.design === activeDesign()));
      const request = {};
      targets.forEach((slot) => { slot.design.photoRequest = request; });
      loadPhotoFile(file).then(({ image, imageUrl, sourceFile }) => {
        const currentSlots = designSlots();
        const validTargets = targets.filter((slot) => slot.design.photoRequest === request && !slot.design.collage && currentSlots.some((current) => current.design === slot.design));
        if (!validTargets.length) { URL.revokeObjectURL(imageUrl); return; }
        validTargets.forEach((slot) => assignPhotoToDesign(slot.design, image, imageUrl, slot.category, sourceFile));
        if (validTargets.some((slot) => slot.design === activeDesign())) {
          state.image = image; state.imageUrl = imageUrl; editor.hidden = false; resetImagePosition();
        }
        if (validTargets.some((slot) => isCollageProduct(slot.category))) invalidateA3Approval();
        updatePhotoProgress(); setStatus('');
      }).catch(() => setStatus(root.dataset.fileTypeError, 'error'));
    });

    fitMode.addEventListener('change', () => {
      const design = activeDesign();
      if (design) design.fitMode = fitMode.value;
      render();
    });
    zoom.addEventListener('input', () => { state.zoom = Number(zoom.value); render(); });
    root.querySelector('[data-rotate-left]').addEventListener('click', () => { state.rotation -= 90; render(); });
    root.querySelector('[data-rotate-right]').addEventListener('click', () => { state.rotation += 90; render(); });
    root.querySelector('[data-reset-image]').addEventListener('click', resetImagePosition);
    root.querySelector('[data-remove-image]').addEventListener('click', clearImage);

    simulators.forEach(({ element, product, rotation }) => {
      rotation.addEventListener('input', () => setPreviewRotation(rotation.value));
      element.querySelectorAll('[data-preview-rotate]').forEach((button) => button.addEventListener('click', () => {
        setPreviewRotation(state.previewRotation + Number(button.dataset.previewRotate));
      }));
      product.addEventListener('pointerdown', (event) => {
        if (!state.image) return;
        state.previewDragging = true;
        state.previewLastX = event.clientX;
        product.setPointerCapture(event.pointerId);
      });
      product.addEventListener('pointermove', (event) => {
        if (!state.previewDragging) return;
        const delta = event.clientX - state.previewLastX;
        state.previewLastX = event.clientX;
        setPreviewRotation(state.previewRotation + delta * 0.8);
      });
      const stopPreviewRotation = () => { state.previewDragging = false; };
      product.addEventListener('pointerup', stopPreviewRotation);
      product.addEventListener('pointercancel', stopPreviewRotation);
      product.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        setPreviewRotation(state.previewRotation + (event.key === 'ArrowLeft' ? -10 : 10));
      });
    });

    canvasWrap.addEventListener('pointerdown', (event) => {
      if (!state.image) return;
      state.dragging = true;
      state.lastX = event.clientX;
      state.lastY = event.clientY;
      canvasWrap.setPointerCapture(event.pointerId);
    });
    canvasWrap.addEventListener('pointermove', (event) => {
      if (!state.dragging) return;
      state.offsetX += event.clientX - state.lastX;
      state.offsetY += event.clientY - state.lastY;
      state.lastX = event.clientX;
      state.lastY = event.clientY;
      render();
    });
    const stopDragging = () => { state.dragging = false; };
    canvasWrap.addEventListener('pointerup', stopDragging);
    canvasWrap.addEventListener('pointercancel', stopDragging);
    window.addEventListener('resize', render);

    const capturePhotoLayers = (context, sources, recipe) => {
      const matrix = () => Array.from(context.getTransform().toFloat64Array()).filter((_, i) => [0, 1, 4, 5, 12, 13].includes(i));
      let path = [], clips = [];
      const stack = [];
      const pathMethods = new Set(['rect', 'ellipse', 'arc', 'moveTo', 'lineTo', 'quadraticCurveTo', 'bezierCurveTo', 'closePath']);
      return new Proxy(context, {
        get(target, key) {
          if (key === 'drawImage') return (image, ...rect) => {
            const photoIndex = sources.findIndex((source) => source.image === image);
            if (photoIndex < 0) return target.drawImage(image, ...rect);
            if (rect.length !== 4) throw new Error(root.dataset.submitError);
            recipe.photos.push({ photo_index: photoIndex + 1, transform: matrix(), rect, clips: structuredClone(clips) });
          };
          if (key === 'save') return () => { stack.push(structuredClone(clips)); target.save(); };
          if (key === 'restore') return () => { clips = stack.pop() || []; target.restore(); };
          if (key === 'beginPath') return () => { path = []; target.beginPath(); };
          if (pathMethods.has(key)) return (...args) => { path.push({ op: key, args, transform: matrix() }); target[key](...args); };
          if (key === 'clip') return (...args) => { clips.push(structuredClone(path)); target.clip(...args); };
          const value = target[key];
          return typeof value === 'function' ? value.bind(target) : value;
        },
        set(target, key, value) { target[key] = value; return true; }
      });
    };

    const createArtworkCanvas = (slot, recipe = null) => {
      if (isCollageProduct(slot.category) && slot.design.collage) {
        const format = collageFormat(slot.design, slot.category);
        if (!a3Complete(slot.design)) throw new Error(`Please add every photo to your ${format.shortLabel} collage before checkout.`);
        if (format.id === 'mug') {
          const selectedMugTheme = mugTheme(slot.design.collage.layout);
          const template = mugThemeImageCache.get(slot.design.collage.layout);
          if (selectedMugTheme.asset && (!template?.complete || !template.naturalWidth)) throw new Error('The selected mug theme is still loading. Please wait a moment and try checkout again.');
        }
        const output = document.createElement('canvas');
        output.width = Math.round(format.widthMm / 25.4 * 300);
        output.height = Math.round(format.heightMm / 25.4 * 300);
        const context = output.getContext('2d');
        drawA3Collage(recipe ? capturePhotoLayers(context, a3Photos(slot.design), recipe) : context, output.width, output.height, slot.design);
        return output;
      }
      activateCategory(slot.key);
      const pixels = outputPixels();
      const output = document.createElement('canvas');
      output.width = pixels.width;
      output.height = pixels.height;
      const outputContext = output.getContext('2d');
      drawArtwork(recipe ? capturePhotoLayers(outputContext, [slot.design], recipe) : outputContext, output.width, output.height, false);
      return output;
    };

    const canvasBlob = (output, type = 'image/png', quality) => new Promise((resolve, reject) => {
      output.toBlob((blob) => blob ? resolve(blob) : reject(new Error(root.dataset.submitError)), type, quality);
    });

    const createEnhancementRecipe = async (slot) => {
      const recipe = { version: 1, photos: [] };
      const background = createArtworkCanvas(slot, recipe);
      recipe.width = background.width;
      recipe.height = background.height;
      if (recipe.photos.length !== originalUploadsForSlot(slot, 0).length) throw new Error(root.dataset.submitError);
      return { recipe, file: new File([await canvasBlob(background)], 'design-background.png', { type: 'image/png' }) };
    };

    const createPrintFile = async (slot) => {
      const output = createArtworkCanvas(slot);
      const blob = await canvasBlob(output, 'image/jpeg', 0.95);
      return new File([blob], `${slot.item.product.toLowerCase().replace(/[^a-z0-9]+/g, '-')}-photo-${slot.copyIndex + 1}-customer-design.jpg`, { type: 'image/jpeg' });
    };

    const originalUploadsForSlot = (slot, designIndex) => {
      const sources = slot.design.collage ? a3Photos(slot.design) : [slot.design];
      return sources.map((source, photoIndex) => ({
        file: source.sourceFile,
        metadata: {
          design_index: designIndex,
          photo_index: photoIndex + 1,
          file_name: source.sourceFile?.name || `original-${photoIndex + 1}`
        }
      })).filter(({ file }) => file instanceof File && file.size > 0);
    };

    const loadTemplateImage = (url) => new Promise((resolve, reject) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('The magnet print template could not be loaded. Please try again.'));
      image.src = url;
    });

    const createMagnetPrintSheet = async (item, bundleIndex) => {
      const photoCount = item.photosPerUnit;
      const layout = magnetSheetLayouts[photoCount];
      const templateUrl = magnetTemplateUrls[photoCount];
      if (!layout || !templateUrl) throw new Error('The selected magnet template is unavailable.');
      const bundleSlots = designSlots()
        .filter((slot) => slot.category === item.category && slot.bundleIndex === bundleIndex)
        .sort((left, right) => left.photoIndex - right.photoIndex);
      if (bundleSlots.length !== photoCount) throw new Error('The magnet bundle is missing one or more photo positions.');

      const output = document.createElement('canvas');
      output.width = 2481;
      output.height = 3509;
      const context = output.getContext('2d');
      const template = await loadTemplateImage(templateUrl);
      context.drawImage(template, 0, 0, output.width, output.height);
      bundleSlots.forEach((slot, index) => {
        const artwork = createArtworkCanvas(slot);
        const position = layout[index];
        context.drawImage(artwork, position.x, position.y, position.width, position.height);
      });

      const blob = await canvasBlob(output, 'image/png');
      const fileName = `magnet-${photoCount}-bundle-${bundleIndex}-a4-print-sheet.png`;
      return {
        file: new File([blob], fileName, { type: 'image/png' }),
        metadata: {
          product: item.product,
          bundle_index: bundleIndex,
          photos_in_bundle: photoCount,
          file_name: fileName,
          width_px: output.width,
          height_px: output.height,
          dpi: 300
        }
      };
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submit.disabled) return;
      if (a3Loading) { setStatus('Please wait for your collage photos to finish loading.', 'error'); return; }
      setStatus('');
      if (!endpoint) return setStatus(root.dataset.serviceUnconfigured, 'error');
      if (!state.items.size) return setStatus(root.dataset.productRequired, 'error');
      if (designSlots().some((slot) => !slot.design.image)) return setStatus(root.dataset.imageRequired, 'error');
      const selectedPaymentMethod = paymentMethod();
      const invalidCheckoutItem = selectedPaymentMethod === 'shopify'
        ? selectedItems().find((item) => !Number.isSafeInteger(item.variantId) || item.variantId <= 0)
        : null;
      if (invalidCheckoutItem) return setStatus(`Checkout is temporarily unavailable for ${invalidCheckoutItem.product}. Please ask a JustBB team member for help.`, 'error');
      if (!form.reportValidity()) return;
      submit.disabled = true;
      // Keep the selected layouts, photos and quantities stable while files are
      // rendered and uploaded. Inert preserves the values included in FormData.
      form.inert = true;
      submit.setAttribute('aria-busy', 'true');
      setStatus(root.dataset.processing);
      try {
        const slots = designSlots();
        const printFiles = [];
        for (const slot of slots) printFiles.push(await createPrintFile(slot));
        const enhancementRecipes = [];
        for (const slot of slots) enhancementRecipes.push(await createEnhancementRecipe(slot));
        const originalUploads = slots.flatMap((slot, designIndex) => originalUploadsForSlot(slot, designIndex));
        const designsWithOriginals = new Set(originalUploads.map(({ metadata }) => metadata.design_index));
        if (designsWithOriginals.size !== slots.length) throw new Error('One or more original uploads could not be preserved. Please choose the photos again.');
        const magnetPrintSheets = [];
        for (const item of selectedItems().filter((candidate) => candidate.photosPerUnit > 1)) {
          for (let bundleIndex = 1; bundleIndex <= item.quantity; bundleIndex += 1) {
            magnetPrintSheets.push(await createMagnetPrintSheet(item, bundleIndex));
          }
        }
        const formData = new FormData(form);
        formData.delete('source_image');
        formData.delete('image');
        printFiles.forEach((file) => formData.append('images', file));
        enhancementRecipes.forEach(({ file }) => formData.append('design_backgrounds', file));
        formData.append('enhancement_recipes', JSON.stringify(enhancementRecipes.map(({ recipe }) => recipe)));
        originalUploads.forEach(({ file }) => formData.append('original_images', file));
        formData.append('original_image_metadata', JSON.stringify(originalUploads.map(({ metadata }) => metadata)));
        magnetPrintSheets.forEach(({ file }) => formData.append('magnet_print_sheets', file));
        formData.append('magnet_print_sheet_metadata', JSON.stringify(magnetPrintSheets.map(({ metadata }) => metadata)));
        setStatus(root.dataset.uploading);
        const response = await fetch(endpoint, { method: 'POST', body: formData });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(payload.error || root.dataset.submitError);
        const orderReference = payload.order_ref || payload.client_order_id || '';
        const clientOrderId = payload.client_order_id || '';
        if (selectedPaymentMethod === 'counter') {
          showConfirmation(orderReference, form.elements.customer_email?.value || '', 'counter');
          setStatus('');
          return;
        }
        const cartItems = selectedItems().map((item) => ({
          id: item.variantId,
          quantity: item.quantity,
          properties: {
            '_JustBB order reference': orderReference,
            '_JustBB client order ID': clientOrderId,
            'Pickup': item.pickup === 'next_day' ? 'Next day pickup' : 'Same day pickup'
          }
        }));
        const cartResponse = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: cartItems })
        });
        const cartPayload = await cartResponse.json().catch(() => ({}));
        if (!cartResponse.ok) throw new Error(cartPayload.description || cartPayload.message || 'Your items could not be added to checkout.');
        sessionStorage.setItem('justbbPendingStallOrder', JSON.stringify({ orderReference, clientOrderId }));
        setStatus('Opening secure Shopify checkout...');
        const discountCode = totalUnits() >= 3 ? 'JUSTBBSTALL3' : totalUnits() === 2 ? 'JUSTBBSTALL2' : '';
        window.location.assign(discountCode ? `/discount/${discountCode}?redirect=/checkout` : '/checkout');
      } catch (error) {
        setStatus(error instanceof Error ? error.message : root.dataset.submitError, 'error');
      } finally {
        form.inert = false;
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["justbb-tumbler-collection-landing"] && !Shopify.designMode) return;
  try {
    
  const tumblerSections = document.querySelectorAll('[data-tumbler-cinema]');
  tumblerSections.forEach((section) => {
    const revealItems = section.querySelectorAll('[data-reveal]');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });

    revealItems.forEach((item) => revealObserver.observe(item));

    const story = section.querySelector('.jbb-tumbler-story');
    if (!story) return;

    const updateStory = () => {
      const rect = story.getBoundingClientRect();
      const distance = rect.height - window.innerHeight;
      const progress = distance > 0 ? Math.min(1, Math.max(0, -rect.top / distance)) : 0;
      section.style.setProperty('--story-progress', progress.toFixed(3));
    };

    updateStory();
    window.addEventListener('scroll', updateStory, { passive: true });
    window.addEventListener('resize', updateStory);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
